
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire2b58"];
var parcelRegister = parcelRequire.register;
parcelRegister("jqHRc", function(module, exports) {

$parcel$export(module.exports, "createCoinbaseWalletSDK", function () { return (parcelRequire("jTmvn")).createCoinbaseWalletSDK; });
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>

var $3NAKy = parcelRequire("3NAKy");

var $jTmvn = parcelRequire("jTmvn");
var $e25277224f28bead$export$2e2bcd8739ae039 = (0, $3NAKy.CoinbaseWalletSDK);

});
parcelRegister("3NAKy", function(module, exports) {

$parcel$export(module.exports, "CoinbaseWalletSDK", function () { return $2c42747989e98529$export$17dc9dbc72da2ce; });
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>

var $fVB9e = parcelRequire("fVB9e");

var $eRkko = parcelRequire("eRkko");

var $jFsv4 = parcelRequire("jFsv4");

var $bujE1 = parcelRequire("bujE1");

var $bJoUW = parcelRequire("bJoUW");

var $lhdkI = parcelRequire("lhdkI");

var $ilDIY = parcelRequire("ilDIY");

var $jzuPG = parcelRequire("jzuPG");
class $2c42747989e98529$export$17dc9dbc72da2ce {
    constructor(metadata){
        this.metadata = {
            appName: metadata.appName || "Dapp",
            appLogoUrl: metadata.appLogoUrl || (0, $bJoUW.getFavicon)(),
            appChainIds: metadata.appChainIds || []
        };
        this.storeLatestVersion();
        (0, $lhdkI.checkCrossOriginOpenerPolicy)();
    }
    makeWeb3Provider(preference = {
        options: "all"
    }) {
        var _a;
        (0, $jzuPG.validatePreferences)(preference);
        const params = {
            metadata: this.metadata,
            preference: preference
        };
        return (_a = (0, $ilDIY.getCoinbaseInjectedProvider)(params)) !== null && _a !== void 0 ? _a : new (0, $eRkko.CoinbaseWalletProvider)(params);
    }
    /**
     * Official Coinbase Wallet logo for developers to use on their frontend
     * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
     * @param width Width of the logo (Optional)
     * @returns SVG Data URI
     */ getCoinbaseWalletLogo(type, width = 240) {
        return (0, $fVB9e.walletLogo)(type, width);
    }
    storeLatestVersion() {
        const versionStorage = new (0, $bujE1.ScopedLocalStorage)("CBWSDK");
        versionStorage.setItem("VERSION", (0, $jFsv4.VERSION));
    }
}

});
parcelRegister("fVB9e", function(module, exports) {

$parcel$export(module.exports, "walletLogo", function () { return $b988feb5dd7e127a$export$318ce2e8614edc46; });
const $b988feb5dd7e127a$export$318ce2e8614edc46 = (type, width)=>{
    let height;
    switch(type){
        case "standard":
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
        case "circle":
            height = width;
            return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
        case "text":
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case "textWithLogo":
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        case "textLight":
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case "textWithLogoLight":
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        default:
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
    }
};

});

parcelRegister("eRkko", function(module, exports) {

$parcel$export(module.exports, "CoinbaseWalletProvider", function () { return $ad15c89f41d20118$export$fb48caf2a73232f9; });

var $iV9CW = parcelRequire("iV9CW");

var $iRDie = parcelRequire("iRDie");

var $j7Ao4 = parcelRequire("j7Ao4");

var $9Zyam = parcelRequire("9Zyam");

var $atSr3 = parcelRequire("atSr3");

var $4qxTb = parcelRequire("4qxTb");

var $fJmlL = parcelRequire("fJmlL");

var $bujE1 = parcelRequire("bujE1");

var $bJoUW = parcelRequire("bJoUW");

var $ilDIY = parcelRequire("ilDIY");
var $ad15c89f41d20118$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $ad15c89f41d20118$export$fb48caf2a73232f9 extends (0, $fJmlL.ProviderEventEmitter) {
    constructor(_a){
        var { metadata: metadata } = _a, _b = _a.preference, { keysUrl: keysUrl } = _b, preference = $ad15c89f41d20118$var$__rest(_b, [
            "keysUrl"
        ]);
        super();
        this.signer = null;
        this.isCoinbaseWallet = true;
        this.metadata = metadata;
        this.preference = preference;
        this.communicator = new (0, $iRDie.Communicator)({
            url: keysUrl,
            metadata: metadata,
            preference: preference
        });
        const signerType = (0, $iV9CW.loadSignerType)();
        if (signerType) this.signer = this.initSigner(signerType);
    }
    async request(args) {
        try {
            (0, $ilDIY.checkErrorForInvalidRequestArgs)(args);
            if (!this.signer) switch(args.method){
                case "eth_requestAccounts":
                    {
                        const signerType = await this.requestSignerSelection(args);
                        const signer = this.initSigner(signerType);
                        await signer.handshake(args);
                        this.signer = signer;
                        (0, $iV9CW.storeSignerType)(signerType);
                        break;
                    }
                case "wallet_sendCalls":
                    {
                        const ephemeralSigner = this.initSigner("scw");
                        await ephemeralSigner.handshake({
                            method: "handshake"
                        }); // exchange session keys
                        const result = await ephemeralSigner.request(args); // send diffie-hellman encrypted request
                        await ephemeralSigner.cleanup(); // clean up (rotate) the ephemeral session keys
                        return result;
                    }
                case "wallet_getCallsStatus":
                    return (0, $ilDIY.fetchRPCRequest)(args, (0, $j7Ao4.CB_WALLET_RPC_URL));
                case "net_version":
                    return 1; // default value
                case "eth_chainId":
                    return (0, $bJoUW.hexStringFromNumber)(1); // default value
                default:
                    throw (0, $atSr3.standardErrors).provider.unauthorized("Must call 'eth_requestAccounts' before other methods");
            }
            return await this.signer.request(args);
        } catch (error) {
            const { code: code } = error;
            if (code === (0, $9Zyam.standardErrorCodes).provider.unauthorized) this.disconnect();
            return Promise.reject((0, $4qxTb.serializeError)(error));
        }
    }
    /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */ async enable() {
        console.warn(`.enable() has been deprecated. Please use .request({ method: "eth_requestAccounts" }) instead.`);
        return await this.request({
            method: "eth_requestAccounts"
        });
    }
    async disconnect() {
        var _a;
        await ((_a = this.signer) === null || _a === void 0 ? void 0 : _a.cleanup());
        this.signer = null;
        (0, $bujE1.ScopedLocalStorage).clearAll();
        this.emit("disconnect", (0, $atSr3.standardErrors).provider.disconnected("User initiated disconnection"));
    }
    requestSignerSelection(handshakeRequest) {
        return (0, $iV9CW.fetchSignerType)({
            communicator: this.communicator,
            preference: this.preference,
            metadata: this.metadata,
            handshakeRequest: handshakeRequest,
            callback: this.emit.bind(this)
        });
    }
    initSigner(signerType) {
        return (0, $iV9CW.createSigner)({
            signerType: signerType,
            metadata: this.metadata,
            communicator: this.communicator,
            callback: this.emit.bind(this)
        });
    }
}

});
parcelRegister("iV9CW", function(module, exports) {

$parcel$export(module.exports, "loadSignerType", function () { return $dc6504963adc4a70$export$ce1c1ccb326c8c5f; });
$parcel$export(module.exports, "storeSignerType", function () { return $dc6504963adc4a70$export$1f56965d4c253b45; });
$parcel$export(module.exports, "fetchSignerType", function () { return $dc6504963adc4a70$export$eada8b999d3eeabb; });
$parcel$export(module.exports, "createSigner", function () { return $dc6504963adc4a70$export$d55591763a67c248; });

var $eZF9S = parcelRequire("eZF9S");

var $3078i = parcelRequire("3078i");

var $bujE1 = parcelRequire("bujE1");
const $dc6504963adc4a70$var$SIGNER_TYPE_KEY = "SignerType";
const $dc6504963adc4a70$var$storage = new (0, $bujE1.ScopedLocalStorage)("CBWSDK", "SignerConfigurator");
function $dc6504963adc4a70$export$ce1c1ccb326c8c5f() {
    return $dc6504963adc4a70$var$storage.getItem($dc6504963adc4a70$var$SIGNER_TYPE_KEY);
}
function $dc6504963adc4a70$export$1f56965d4c253b45(signerType) {
    $dc6504963adc4a70$var$storage.setItem($dc6504963adc4a70$var$SIGNER_TYPE_KEY, signerType);
}
async function $dc6504963adc4a70$export$eada8b999d3eeabb(params) {
    const { communicator: communicator, metadata: metadata, handshakeRequest: handshakeRequest, callback: callback } = params;
    $dc6504963adc4a70$var$listenForWalletLinkSessionRequest(communicator, metadata, callback).catch(()=>{});
    const request = {
        id: crypto.randomUUID(),
        event: "selectSignerType",
        data: Object.assign(Object.assign({}, params.preference), {
            handshakeRequest: handshakeRequest
        })
    };
    const { data: data } = await communicator.postRequestAndWaitForResponse(request);
    return data;
}
function $dc6504963adc4a70$export$d55591763a67c248(params) {
    const { signerType: signerType, metadata: metadata, communicator: communicator, callback: callback } = params;
    switch(signerType){
        case "scw":
            return new (0, $eZF9S.SCWSigner)({
                metadata: metadata,
                callback: callback,
                communicator: communicator
            });
        case "walletlink":
            return new (0, $3078i.WalletLinkSigner)({
                metadata: metadata,
                callback: callback
            });
    }
}
async function $dc6504963adc4a70$var$listenForWalletLinkSessionRequest(communicator, metadata, callback) {
    await communicator.onMessage(({ event: event })=>event === "WalletLinkSessionRequest");
    // temporary walletlink signer instance to handle WalletLinkSessionRequest
    // will revisit this when refactoring the walletlink signer
    const walletlink = new (0, $3078i.WalletLinkSigner)({
        metadata: metadata,
        callback: callback
    });
    // send wallet link session to popup
    communicator.postMessage({
        event: "WalletLinkUpdate",
        data: {
            session: walletlink.getSession()
        }
    });
    // wait for handshake to complete
    await walletlink.handshake();
    // send connected status to popup
    communicator.postMessage({
        event: "WalletLinkUpdate",
        data: {
            connected: true
        }
    });
}

});
parcelRegister("eZF9S", function(module, exports) {

$parcel$export(module.exports, "SCWSigner", function () { return $aea6b0608510d96c$export$d3edf51c925eb793; });

var $lCEn0 = parcelRequire("lCEn0");

var $atSr3 = parcelRequire("atSr3");

var $bujE1 = parcelRequire("bujE1");

var $bJoUW = parcelRequire("bJoUW");

var $8gZum = parcelRequire("8gZum");

var $ilDIY = parcelRequire("ilDIY");
const $aea6b0608510d96c$var$ACCOUNTS_KEY = "accounts";
const $aea6b0608510d96c$var$ACTIVE_CHAIN_STORAGE_KEY = "activeChain";
const $aea6b0608510d96c$var$AVAILABLE_CHAINS_STORAGE_KEY = "availableChains";
const $aea6b0608510d96c$var$WALLET_CAPABILITIES_STORAGE_KEY = "walletCapabilities";
class $aea6b0608510d96c$export$d3edf51c925eb793 {
    constructor(params){
        var _a, _b, _c;
        this.metadata = params.metadata;
        this.communicator = params.communicator;
        this.callback = params.callback;
        this.keyManager = new (0, $lCEn0.SCWKeyManager)();
        this.storage = new (0, $bujE1.ScopedLocalStorage)("CBWSDK", "SCWStateManager");
        this.accounts = (_a = this.storage.loadObject($aea6b0608510d96c$var$ACCOUNTS_KEY)) !== null && _a !== void 0 ? _a : [];
        this.chain = this.storage.loadObject($aea6b0608510d96c$var$ACTIVE_CHAIN_STORAGE_KEY) || {
            id: (_c = (_b = params.metadata.appChainIds) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 1
        };
        this.handshake = this.handshake.bind(this);
        this.request = this.request.bind(this);
        this.createRequestMessage = this.createRequestMessage.bind(this);
        this.decryptResponseMessage = this.decryptResponseMessage.bind(this);
    }
    async handshake(args) {
        var _a, _b, _c, _d;
        // Open the popup before constructing the request message.
        // This is to ensure that the popup is not blocked by some browsers (i.e. Safari)
        await ((_b = (_a = this.communicator).waitForPopupLoaded) === null || _b === void 0 ? void 0 : _b.call(_a));
        const handshakeMessage = await this.createRequestMessage({
            handshake: {
                method: args.method,
                params: Object.assign({}, this.metadata, (_c = args.params) !== null && _c !== void 0 ? _c : {})
            }
        });
        const response = await this.communicator.postRequestAndWaitForResponse(handshakeMessage);
        // store peer's public key
        if ("failure" in response.content) throw response.content.failure;
        const peerPublicKey = await (0, $8gZum.importKeyFromHexString)("public", response.sender);
        await this.keyManager.setPeerPublicKey(peerPublicKey);
        const decrypted = await this.decryptResponseMessage(response);
        const result = decrypted.result;
        if ("error" in result) throw result.error;
        switch(args.method){
            case "eth_requestAccounts":
                {
                    const accounts = result.value;
                    this.accounts = accounts;
                    this.storage.storeObject($aea6b0608510d96c$var$ACCOUNTS_KEY, accounts);
                    (_d = this.callback) === null || _d === void 0 || _d.call(this, "accountsChanged", accounts);
                    break;
                }
        }
    }
    async request(request) {
        var _a;
        if (this.accounts.length === 0) switch(request.method){
            case "wallet_sendCalls":
                return this.sendRequestToPopup(request);
            default:
                throw (0, $atSr3.standardErrors).provider.unauthorized();
        }
        switch(request.method){
            case "eth_requestAccounts":
                (_a = this.callback) === null || _a === void 0 || _a.call(this, "connect", {
                    chainId: (0, $bJoUW.hexStringFromNumber)(this.chain.id)
                });
                return this.accounts;
            case "eth_accounts":
                return this.accounts;
            case "eth_coinbase":
                return this.accounts[0];
            case "net_version":
                return this.chain.id;
            case "eth_chainId":
                return (0, $bJoUW.hexStringFromNumber)(this.chain.id);
            case "wallet_getCapabilities":
                return this.storage.loadObject($aea6b0608510d96c$var$WALLET_CAPABILITIES_STORAGE_KEY);
            case "wallet_switchEthereumChain":
                return this.handleSwitchChainRequest(request);
            case "eth_ecRecover":
            case "personal_sign":
            case "wallet_sign":
            case "personal_ecRecover":
            case "eth_signTransaction":
            case "eth_sendTransaction":
            case "eth_signTypedData_v1":
            case "eth_signTypedData_v3":
            case "eth_signTypedData_v4":
            case "eth_signTypedData":
            case "wallet_addEthereumChain":
            case "wallet_watchAsset":
            case "wallet_sendCalls":
            case "wallet_showCallsStatus":
            case "wallet_grantPermissions":
                return this.sendRequestToPopup(request);
            default:
                if (!this.chain.rpcUrl) throw (0, $atSr3.standardErrors).rpc.internal("No RPC URL set for chain");
                return (0, $ilDIY.fetchRPCRequest)(request, this.chain.rpcUrl);
        }
    }
    async sendRequestToPopup(request) {
        var _a, _b;
        // Open the popup before constructing the request message.
        // This is to ensure that the popup is not blocked by some browsers (i.e. Safari)
        await ((_b = (_a = this.communicator).waitForPopupLoaded) === null || _b === void 0 ? void 0 : _b.call(_a));
        const response = await this.sendEncryptedRequest(request);
        const decrypted = await this.decryptResponseMessage(response);
        const result = decrypted.result;
        if ("error" in result) throw result.error;
        return result.value;
    }
    async cleanup() {
        var _a, _b;
        this.storage.clear();
        await this.keyManager.clear();
        this.accounts = [];
        this.chain = {
            id: (_b = (_a = this.metadata.appChainIds) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 1
        };
    }
    /**
     * @returns `null` if the request was successful.
     * https://eips.ethereum.org/EIPS/eip-3326#wallet_switchethereumchain
     */ async handleSwitchChainRequest(request) {
        var _a;
        const params = request.params;
        if (!params || !((_a = params[0]) === null || _a === void 0 ? void 0 : _a.chainId)) throw (0, $atSr3.standardErrors).rpc.invalidParams();
        const chainId = (0, $bJoUW.ensureIntNumber)(params[0].chainId);
        const localResult = this.updateChain(chainId);
        if (localResult) return null;
        const popupResult = await this.sendRequestToPopup(request);
        if (popupResult === null) this.updateChain(chainId);
        return popupResult;
    }
    async sendEncryptedRequest(request) {
        const sharedSecret = await this.keyManager.getSharedSecret();
        if (!sharedSecret) throw (0, $atSr3.standardErrors).provider.unauthorized("No valid session found, try requestAccounts before other methods");
        const encrypted = await (0, $8gZum.encryptContent)({
            action: request,
            chainId: this.chain.id
        }, sharedSecret);
        const message = await this.createRequestMessage({
            encrypted: encrypted
        });
        return this.communicator.postRequestAndWaitForResponse(message);
    }
    async createRequestMessage(content) {
        const publicKey = await (0, $8gZum.exportKeyToHexString)("public", await this.keyManager.getOwnPublicKey());
        return {
            id: crypto.randomUUID(),
            sender: publicKey,
            content: content,
            timestamp: new Date()
        };
    }
    async decryptResponseMessage(message) {
        var _a, _b;
        const content = message.content;
        // throw protocol level error
        if ("failure" in content) throw content.failure;
        const sharedSecret = await this.keyManager.getSharedSecret();
        if (!sharedSecret) throw (0, $atSr3.standardErrors).provider.unauthorized("Invalid session");
        const response = await (0, $8gZum.decryptContent)(content.encrypted, sharedSecret);
        const availableChains = (_a = response.data) === null || _a === void 0 ? void 0 : _a.chains;
        if (availableChains) {
            const chains = Object.entries(availableChains).map(([id, rpcUrl])=>({
                    id: Number(id),
                    rpcUrl: rpcUrl
                }));
            this.storage.storeObject($aea6b0608510d96c$var$AVAILABLE_CHAINS_STORAGE_KEY, chains);
            this.updateChain(this.chain.id, chains);
        }
        const walletCapabilities = (_b = response.data) === null || _b === void 0 ? void 0 : _b.capabilities;
        if (walletCapabilities) this.storage.storeObject($aea6b0608510d96c$var$WALLET_CAPABILITIES_STORAGE_KEY, walletCapabilities);
        return response;
    }
    updateChain(chainId, newAvailableChains) {
        var _a;
        const chains = newAvailableChains !== null && newAvailableChains !== void 0 ? newAvailableChains : this.storage.loadObject($aea6b0608510d96c$var$AVAILABLE_CHAINS_STORAGE_KEY);
        const chain = chains === null || chains === void 0 ? void 0 : chains.find((chain)=>chain.id === chainId);
        if (!chain) return false;
        if (chain !== this.chain) {
            this.chain = chain;
            this.storage.storeObject($aea6b0608510d96c$var$ACTIVE_CHAIN_STORAGE_KEY, chain);
            (_a = this.callback) === null || _a === void 0 || _a.call(this, "chainChanged", (0, $bJoUW.hexStringFromNumber)(chain.id));
        }
        return true;
    }
}

});
parcelRegister("lCEn0", function(module, exports) {

$parcel$export(module.exports, "SCWKeyManager", function () { return $fbdc763c77ac9d8d$export$1f76b9dfed1c53da; });

var $bujE1 = parcelRequire("bujE1");

var $8gZum = parcelRequire("8gZum");
const $fbdc763c77ac9d8d$var$OWN_PRIVATE_KEY = {
    storageKey: "ownPrivateKey",
    keyType: "private"
};
const $fbdc763c77ac9d8d$var$OWN_PUBLIC_KEY = {
    storageKey: "ownPublicKey",
    keyType: "public"
};
const $fbdc763c77ac9d8d$var$PEER_PUBLIC_KEY = {
    storageKey: "peerPublicKey",
    keyType: "public"
};
class $fbdc763c77ac9d8d$export$1f76b9dfed1c53da {
    constructor(){
        this.storage = new (0, $bujE1.ScopedLocalStorage)("CBWSDK", "SCWKeyManager");
        this.ownPrivateKey = null;
        this.ownPublicKey = null;
        this.peerPublicKey = null;
        this.sharedSecret = null;
    }
    async getOwnPublicKey() {
        await this.loadKeysIfNeeded();
        return this.ownPublicKey;
    }
    // returns null if the shared secret is not yet derived
    async getSharedSecret() {
        await this.loadKeysIfNeeded();
        return this.sharedSecret;
    }
    async setPeerPublicKey(key) {
        this.sharedSecret = null;
        this.peerPublicKey = key;
        await this.storeKey($fbdc763c77ac9d8d$var$PEER_PUBLIC_KEY, key);
        await this.loadKeysIfNeeded();
    }
    async clear() {
        this.ownPrivateKey = null;
        this.ownPublicKey = null;
        this.peerPublicKey = null;
        this.sharedSecret = null;
        this.storage.removeItem($fbdc763c77ac9d8d$var$OWN_PUBLIC_KEY.storageKey);
        this.storage.removeItem($fbdc763c77ac9d8d$var$OWN_PRIVATE_KEY.storageKey);
        this.storage.removeItem($fbdc763c77ac9d8d$var$PEER_PUBLIC_KEY.storageKey);
    }
    async generateKeyPair() {
        const newKeyPair = await (0, $8gZum.generateKeyPair)();
        this.ownPrivateKey = newKeyPair.privateKey;
        this.ownPublicKey = newKeyPair.publicKey;
        await this.storeKey($fbdc763c77ac9d8d$var$OWN_PRIVATE_KEY, newKeyPair.privateKey);
        await this.storeKey($fbdc763c77ac9d8d$var$OWN_PUBLIC_KEY, newKeyPair.publicKey);
    }
    async loadKeysIfNeeded() {
        if (this.ownPrivateKey === null) this.ownPrivateKey = await this.loadKey($fbdc763c77ac9d8d$var$OWN_PRIVATE_KEY);
        if (this.ownPublicKey === null) this.ownPublicKey = await this.loadKey($fbdc763c77ac9d8d$var$OWN_PUBLIC_KEY);
        if (this.ownPrivateKey === null || this.ownPublicKey === null) await this.generateKeyPair();
        if (this.peerPublicKey === null) this.peerPublicKey = await this.loadKey($fbdc763c77ac9d8d$var$PEER_PUBLIC_KEY);
        if (this.sharedSecret === null) {
            if (this.ownPrivateKey === null || this.peerPublicKey === null) return;
            this.sharedSecret = await (0, $8gZum.deriveSharedSecret)(this.ownPrivateKey, this.peerPublicKey);
        }
    }
    // storage methods
    async loadKey(item) {
        const key = this.storage.getItem(item.storageKey);
        if (!key) return null;
        return (0, $8gZum.importKeyFromHexString)(item.keyType, key);
    }
    async storeKey(item, key) {
        const hexString = await (0, $8gZum.exportKeyToHexString)(item.keyType, key);
        this.storage.setItem(item.storageKey, hexString);
    }
}

});
parcelRegister("bujE1", function(module, exports) {

$parcel$export(module.exports, "ScopedLocalStorage", function () { return $85d1bc10beecee24$export$4342fc1ef14489e4; });
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
// TODO: clean up, or possibly deprecate Storage class
class $85d1bc10beecee24$export$4342fc1ef14489e4 {
    constructor(scope, module){
        this.scope = scope;
        this.module = module;
    }
    storeObject(key, item) {
        this.setItem(key, JSON.stringify(item));
    }
    loadObject(key) {
        const item = this.getItem(key);
        return item ? JSON.parse(item) : undefined;
    }
    setItem(key, value) {
        localStorage.setItem(this.scopedKey(key), value);
    }
    getItem(key) {
        return localStorage.getItem(this.scopedKey(key));
    }
    removeItem(key) {
        localStorage.removeItem(this.scopedKey(key));
    }
    clear() {
        const prefix = this.scopedKey("");
        const keysToRemove = [];
        for(let i = 0; i < localStorage.length; i++){
            const key = localStorage.key(i);
            if (typeof key === "string" && key.startsWith(prefix)) keysToRemove.push(key);
        }
        keysToRemove.forEach((key)=>localStorage.removeItem(key));
    }
    scopedKey(key) {
        return `-${this.scope}${this.module ? `:${this.module}` : ""}:${key}`;
    }
    static clearAll() {
        new $85d1bc10beecee24$export$4342fc1ef14489e4("CBWSDK").clear();
        new $85d1bc10beecee24$export$4342fc1ef14489e4("walletlink").clear();
    }
}

});

parcelRegister("8gZum", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", function () { return $605f83be031b7a1e$export$a949d36eab55b41f; });
$parcel$export(module.exports, "deriveSharedSecret", function () { return $605f83be031b7a1e$export$d8c619be39dc35fe; });
$parcel$export(module.exports, "exportKeyToHexString", function () { return $605f83be031b7a1e$export$32bb7f8d395d5e63; });
$parcel$export(module.exports, "importKeyFromHexString", function () { return $605f83be031b7a1e$export$b589b432d4ebdd99; });
$parcel$export(module.exports, "encryptContent", function () { return $605f83be031b7a1e$export$f7e3284783ba406; });
$parcel$export(module.exports, "decryptContent", function () { return $605f83be031b7a1e$export$5d2baf1126c0485e; });

var $bJoUW = parcelRequire("bJoUW");
async function $605f83be031b7a1e$export$a949d36eab55b41f() {
    return crypto.subtle.generateKey({
        name: "ECDH",
        namedCurve: "P-256"
    }, true, [
        "deriveKey"
    ]);
}
async function $605f83be031b7a1e$export$d8c619be39dc35fe(ownPrivateKey, peerPublicKey) {
    return crypto.subtle.deriveKey({
        name: "ECDH",
        public: peerPublicKey
    }, ownPrivateKey, {
        name: "AES-GCM",
        length: 256
    }, false, [
        "encrypt",
        "decrypt"
    ]);
}
async function $605f83be031b7a1e$export$5b0f6292f11d1d18(sharedSecret, plainText) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const cipherText = await crypto.subtle.encrypt({
        name: "AES-GCM",
        iv: iv
    }, sharedSecret, new TextEncoder().encode(plainText));
    return {
        iv: iv,
        cipherText: cipherText
    };
}
async function $605f83be031b7a1e$export$e85a0c9a1067c5d3(sharedSecret, { iv: iv, cipherText: cipherText }) {
    const plainText = await crypto.subtle.decrypt({
        name: "AES-GCM",
        iv: iv
    }, sharedSecret, cipherText);
    return new TextDecoder().decode(plainText);
}
function $605f83be031b7a1e$var$getFormat(keyType) {
    switch(keyType){
        case "public":
            return "spki";
        case "private":
            return "pkcs8";
    }
}
async function $605f83be031b7a1e$export$32bb7f8d395d5e63(type, key) {
    const format = $605f83be031b7a1e$var$getFormat(type);
    const exported = await crypto.subtle.exportKey(format, key);
    return (0, $bJoUW.uint8ArrayToHex)(new Uint8Array(exported));
}
async function $605f83be031b7a1e$export$b589b432d4ebdd99(type, hexString) {
    const format = $605f83be031b7a1e$var$getFormat(type);
    const arrayBuffer = (0, $bJoUW.hexStringToUint8Array)(hexString).buffer;
    return await crypto.subtle.importKey(format, new Uint8Array(arrayBuffer), {
        name: "ECDH",
        namedCurve: "P-256"
    }, true, type === "private" ? [
        "deriveKey"
    ] : []);
}
async function $605f83be031b7a1e$export$f7e3284783ba406(content, sharedSecret) {
    const serialized = JSON.stringify(content, (_, value)=>{
        if (!(value instanceof Error)) return value;
        const error = value;
        return Object.assign(Object.assign({}, error.code ? {
            code: error.code
        } : {}), {
            message: error.message
        });
    });
    return $605f83be031b7a1e$export$5b0f6292f11d1d18(sharedSecret, serialized);
}
async function $605f83be031b7a1e$export$5d2baf1126c0485e(encryptedData, sharedSecret) {
    return JSON.parse(await $605f83be031b7a1e$export$e85a0c9a1067c5d3(sharedSecret, encryptedData));
}

});
parcelRegister("bJoUW", function(module, exports) {

$parcel$export(module.exports, "randomBytesHex", function () { return $88a739bdf286552c$export$64ad75985647cf0; });
$parcel$export(module.exports, "uint8ArrayToHex", function () { return $88a739bdf286552c$export$c44b02fb03dbac82; });
$parcel$export(module.exports, "hexStringToUint8Array", function () { return $88a739bdf286552c$export$e0b70b88274897fe; });
$parcel$export(module.exports, "hexStringFromBuffer", function () { return $88a739bdf286552c$export$e6f7318e1777e9fe; });
$parcel$export(module.exports, "encodeToHexString", function () { return $88a739bdf286552c$export$818e6e20395551fb; });
$parcel$export(module.exports, "ensureBuffer", function () { return $88a739bdf286552c$export$1c55ce49a3537f6d; });
$parcel$export(module.exports, "bigIntStringFromBigInt", function () { return $88a739bdf286552c$export$513411e0f97eeef0; });
$parcel$export(module.exports, "hexStringFromNumber", function () { return $88a739bdf286552c$export$181f5aef1d14e52e; });
$parcel$export(module.exports, "prepend0x", function () { return $88a739bdf286552c$export$4eaf351e3d1b79ad; });
$parcel$export(module.exports, "ensureAddressString", function () { return $88a739bdf286552c$export$59b10fd5a90c9025; });
$parcel$export(module.exports, "ensureIntNumber", function () { return $88a739bdf286552c$export$bdcbaec547680dc8; });
$parcel$export(module.exports, "ensureBigInt", function () { return $88a739bdf286552c$export$a21ccaa51809fee2; });
$parcel$export(module.exports, "ensureParsedJSONObject", function () { return $88a739bdf286552c$export$71dea1b2324cab7b; });
$parcel$export(module.exports, "getFavicon", function () { return $88a739bdf286552c$export$30c2a0095db95d06; });
/* eslint-disable @typescript-eslint/no-explicit-any */ // Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $atSr3 = parcelRequire("atSr3");

var $hJw2S = parcelRequire("hJw2S");

var $98IaM = parcelRequire("98IaM");
var $88a739bdf286552c$require$Buffer = $98IaM.Buffer;
const $88a739bdf286552c$var$INT_STRING_REGEX = /^[0-9]*$/;
const $88a739bdf286552c$var$HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
function $88a739bdf286552c$export$64ad75985647cf0(length) {
    return $88a739bdf286552c$export$c44b02fb03dbac82(crypto.getRandomValues(new Uint8Array(length)));
}
function $88a739bdf286552c$export$c44b02fb03dbac82(value) {
    return [
        ...value
    ].map((b)=>b.toString(16).padStart(2, "0")).join("");
}
function $88a739bdf286552c$export$e0b70b88274897fe(hexString) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map((byte)=>Number.parseInt(byte, 16)));
}
function $88a739bdf286552c$export$e6f7318e1777e9fe(buf, includePrefix = false) {
    const hex = buf.toString("hex");
    return (0, $hJw2S.HexString)(includePrefix ? `0x${hex}` : hex);
}
function $88a739bdf286552c$export$818e6e20395551fb(str) {
    return $88a739bdf286552c$export$e6f7318e1777e9fe($88a739bdf286552c$export$1c55ce49a3537f6d(str), true);
}
function $88a739bdf286552c$export$513411e0f97eeef0(bi) {
    return (0, $hJw2S.BigIntString)(bi.toString(10));
}
function $88a739bdf286552c$export$649e38a4f2a3ee9a(hex) {
    return (0, $hJw2S.IntNumber)(Number(BigInt($88a739bdf286552c$export$d866e7279a8132a8(hex, true))));
}
function $88a739bdf286552c$export$181f5aef1d14e52e(num) {
    return (0, $hJw2S.HexString)(`0x${BigInt(num).toString(16)}`);
}
function $88a739bdf286552c$export$19510906a1e41b28(str) {
    return str.startsWith("0x") || str.startsWith("0X");
}
function $88a739bdf286552c$export$92cb46da72901f83(hex) {
    if ($88a739bdf286552c$export$19510906a1e41b28(hex)) return hex.slice(2);
    return hex;
}
function $88a739bdf286552c$export$4eaf351e3d1b79ad(hex) {
    if ($88a739bdf286552c$export$19510906a1e41b28(hex)) return `0x${hex.slice(2)}`;
    return `0x${hex}`;
}
function $88a739bdf286552c$export$b02a40aff8e4ad18(hex) {
    if (typeof hex !== "string") return false;
    const s = $88a739bdf286552c$export$92cb46da72901f83(hex).toLowerCase();
    return $88a739bdf286552c$var$HEXADECIMAL_STRING_REGEX.test(s);
}
function $88a739bdf286552c$export$4788e037582e1df2(hex, includePrefix = false) {
    if (typeof hex === "string") {
        const s = $88a739bdf286552c$export$92cb46da72901f83(hex).toLowerCase();
        if ($88a739bdf286552c$var$HEXADECIMAL_STRING_REGEX.test(s)) return (0, $hJw2S.HexString)(includePrefix ? `0x${s}` : s);
    }
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`"${String(hex)}" is not a hexadecimal string`);
}
function $88a739bdf286552c$export$d866e7279a8132a8(hex, includePrefix = false) {
    let h = $88a739bdf286552c$export$4788e037582e1df2(hex, false);
    if (h.length % 2 === 1) h = (0, $hJw2S.HexString)(`0${h}`);
    return includePrefix ? (0, $hJw2S.HexString)(`0x${h}`) : h;
}
function $88a739bdf286552c$export$59b10fd5a90c9025(str) {
    if (typeof str === "string") {
        const s = $88a739bdf286552c$export$92cb46da72901f83(str).toLowerCase();
        if ($88a739bdf286552c$export$b02a40aff8e4ad18(s) && s.length === 40) return (0, $hJw2S.AddressString)($88a739bdf286552c$export$4eaf351e3d1b79ad(s));
    }
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Invalid Ethereum address: ${String(str)}`);
}
function $88a739bdf286552c$export$1c55ce49a3537f6d(str) {
    if ($88a739bdf286552c$require$Buffer.isBuffer(str)) return str;
    if (typeof str === "string") {
        if ($88a739bdf286552c$export$b02a40aff8e4ad18(str)) {
            const s = $88a739bdf286552c$export$d866e7279a8132a8(str, false);
            return $88a739bdf286552c$require$Buffer.from(s, "hex");
        }
        return $88a739bdf286552c$require$Buffer.from(str, "utf8");
    }
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Not binary data: ${String(str)}`);
}
function $88a739bdf286552c$export$bdcbaec547680dc8(num) {
    if (typeof num === "number" && Number.isInteger(num)) return (0, $hJw2S.IntNumber)(num);
    if (typeof num === "string") {
        if ($88a739bdf286552c$var$INT_STRING_REGEX.test(num)) return (0, $hJw2S.IntNumber)(Number(num));
        if ($88a739bdf286552c$export$b02a40aff8e4ad18(num)) return (0, $hJw2S.IntNumber)(Number(BigInt($88a739bdf286552c$export$d866e7279a8132a8(num, true))));
    }
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Not an integer: ${String(num)}`);
}
function $88a739bdf286552c$export$3c12a147cb6f2a91(regExp) {
    if (regExp instanceof RegExp) return (0, $hJw2S.RegExpString)(regExp.toString());
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Not a RegExp: ${String(regExp)}`);
}
function $88a739bdf286552c$export$a21ccaa51809fee2(val) {
    if (val !== null && (typeof val === "bigint" || $88a739bdf286552c$export$e51d0e7e5c4a03ab(val))) return BigInt(val.toString(10));
    if (typeof val === "number") return BigInt($88a739bdf286552c$export$bdcbaec547680dc8(val));
    if (typeof val === "string") {
        if ($88a739bdf286552c$var$INT_STRING_REGEX.test(val)) return BigInt(val);
        if ($88a739bdf286552c$export$b02a40aff8e4ad18(val)) return BigInt($88a739bdf286552c$export$d866e7279a8132a8(val, true));
    }
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Not an integer: ${String(val)}`);
}
function $88a739bdf286552c$export$71dea1b2324cab7b(val) {
    if (typeof val === "string") return JSON.parse(val);
    if (typeof val === "object") return val;
    throw (0, $atSr3.standardErrors).rpc.invalidParams(`Not a JSON string or an object: ${String(val)}`);
}
function $88a739bdf286552c$export$e51d0e7e5c4a03ab(val) {
    if (val == null || typeof val.constructor !== "function") return false;
    const { constructor: constructor } = val;
    return typeof constructor.config === "function" && typeof constructor.EUCLID === "number";
}
function $88a739bdf286552c$export$d02631cccf789723(start, stop) {
    return Array.from({
        length: stop - start
    }, (_, i)=>start + i);
}
function $88a739bdf286552c$export$30c2a0095db95d06() {
    const el = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    const { protocol: protocol, host: host } = document.location;
    const href = el ? el.getAttribute("href") : null;
    if (!href || href.startsWith("javascript:") || href.startsWith("vbscript:")) return `${protocol}//${host}/favicon.ico`; // fallback
    if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("data:")) return href;
    if (href.startsWith("//")) return protocol + href;
    return `${protocol}//${host}${href}`;
}
function $88a739bdf286552c$export$4d97dbb4d6eb7ac5(arr1, arr2) {
    return arr1.length === arr2.length && arr1.every((value, index)=>value === arr2[index]);
}

});
parcelRegister("atSr3", function(module, exports) {

$parcel$export(module.exports, "standardErrors", function () { return $7a16d69031f90c92$export$b0da1311d1fb4327; });

var $9Zyam = parcelRequire("9Zyam");

var $7Xld6 = parcelRequire("7Xld6");
const $7a16d69031f90c92$export$b0da1311d1fb4327 = {
    rpc: {
        parse: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.parse, arg),
        invalidRequest: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.invalidRequest, arg),
        invalidParams: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.invalidParams, arg),
        methodNotFound: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.methodNotFound, arg),
        internal: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.internal, arg),
        server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code: code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $7a16d69031f90c92$var$getEthJsonRpcError(code, opts);
        },
        invalidInput: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.invalidInput, arg),
        resourceNotFound: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.resourceNotFound, arg),
        resourceUnavailable: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.resourceUnavailable, arg),
        transactionRejected: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.transactionRejected, arg),
        methodNotSupported: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.methodNotSupported, arg),
        limitExceeded: (arg)=>$7a16d69031f90c92$var$getEthJsonRpcError((0, $9Zyam.standardErrorCodes).rpc.limitExceeded, arg)
    },
    provider: {
        userRejectedRequest: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.userRejectedRequest, arg);
        },
        unauthorized: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.unauthorized, arg);
        },
        unsupportedMethod: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.unsupportedMethod, arg);
        },
        disconnected: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.disconnected, arg);
        },
        chainDisconnected: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.chainDisconnected, arg);
        },
        unsupportedChain: (arg)=>{
            return $7a16d69031f90c92$var$getEthProviderError((0, $9Zyam.standardErrorCodes).provider.unsupportedChain, arg);
        },
        custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code: code, message: message, data: data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $7a16d69031f90c92$var$EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $7a16d69031f90c92$var$getEthJsonRpcError(code, arg) {
    const [message, data] = $7a16d69031f90c92$var$parseOpts(arg);
    return new $7a16d69031f90c92$var$EthereumRpcError(code, message || (0, $7Xld6.getMessageFromCode)(code), data);
}
function $7a16d69031f90c92$var$getEthProviderError(code, arg) {
    const [message, data] = $7a16d69031f90c92$var$parseOpts(arg);
    return new $7a16d69031f90c92$var$EthereumProviderError(code, message || (0, $7Xld6.getMessageFromCode)(code), data);
}
function $7a16d69031f90c92$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message: message, data: data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}
class $7a16d69031f90c92$var$EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
}
class $7a16d69031f90c92$var$EthereumProviderError extends $7a16d69031f90c92$var$EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!$7a16d69031f90c92$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
function $7a16d69031f90c92$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}

});
parcelRegister("9Zyam", function(module, exports) {

$parcel$export(module.exports, "standardErrorCodes", function () { return $74645039707a10e3$export$a5593fc5331e295b; });
$parcel$export(module.exports, "errorValues", function () { return $74645039707a10e3$export$ccc4911828a5d2a9; });
const $74645039707a10e3$export$a5593fc5331e295b = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901,
        unsupportedChain: 4902
    }
};
const $74645039707a10e3$export$ccc4911828a5d2a9 = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    },
    "4902": {
        standard: "EIP-3085",
        message: "Unrecognized chain ID."
    }
};

});

parcelRegister("7Xld6", function(module, exports) {

$parcel$export(module.exports, "getMessageFromCode", function () { return $5cae7f051e904190$export$ba84253034eb1ef9; });
$parcel$export(module.exports, "serialize", function () { return $5cae7f051e904190$export$dfdc1655ccc5b9cb; });

var $9Zyam = parcelRequire("9Zyam");
const $5cae7f051e904190$var$FALLBACK_MESSAGE = "Unspecified error message.";
const $5cae7f051e904190$export$d7661873da4445c1 = "Unspecified server error.";
function $5cae7f051e904190$export$ba84253034eb1ef9(code, fallbackMessage = $5cae7f051e904190$var$FALLBACK_MESSAGE) {
    if (code && Number.isInteger(code)) {
        const codeString = code.toString();
        if ($5cae7f051e904190$var$hasKey((0, $9Zyam.errorValues), codeString)) return (0, $9Zyam.errorValues)[codeString].message;
        if ($5cae7f051e904190$var$isJsonRpcServerError(code)) return $5cae7f051e904190$export$d7661873da4445c1;
    }
    return fallbackMessage;
}
function $5cae7f051e904190$export$a5c39676d2a86af8(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if ((0, $9Zyam.errorValues)[codeString]) return true;
    if ($5cae7f051e904190$var$isJsonRpcServerError(code)) return true;
    return false;
}
function $5cae7f051e904190$export$ab5c47d1a2f2c859(error) {
    var _a;
    if (typeof error === "number") return error;
    else if ($5cae7f051e904190$var$isErrorWithCode(error)) return (_a = error.code) !== null && _a !== void 0 ? _a : error.errorCode;
    return undefined;
}
function $5cae7f051e904190$var$isErrorWithCode(error) {
    return typeof error === "object" && error !== null && (typeof error.code === "number" || typeof error.errorCode === "number");
}
function $5cae7f051e904190$export$dfdc1655ccc5b9cb(error, { shouldIncludeStack: shouldIncludeStack = false } = {}) {
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $5cae7f051e904190$var$hasKey(error, "code") && $5cae7f051e904190$export$a5c39676d2a86af8(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($5cae7f051e904190$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $5cae7f051e904190$export$ba84253034eb1ef9(serialized.code);
            serialized.data = {
                originalError: $5cae7f051e904190$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = (0, $9Zyam.standardErrorCodes).rpc.internal;
        serialized.message = $5cae7f051e904190$var$hasStringProperty(error, "message") ? error.message : $5cae7f051e904190$var$FALLBACK_MESSAGE;
        serialized.data = {
            originalError: $5cae7f051e904190$var$assignOriginalError(error)
        };
    }
    if (shouldIncludeStack) serialized.stack = $5cae7f051e904190$var$hasStringProperty(error, "stack") ? error.stack : undefined;
    return serialized;
}
// Internal
function $5cae7f051e904190$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $5cae7f051e904190$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $5cae7f051e904190$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $5cae7f051e904190$var$hasStringProperty(obj, prop) {
    return typeof obj === "object" && obj !== null && prop in obj && typeof obj[prop] === "string";
}

});


parcelRegister("hJw2S", function(module, exports) {

$parcel$export(module.exports, "HexString", function () { return $ce8f7f35ea23371e$export$8eb9ec7304489e21; });
$parcel$export(module.exports, "AddressString", function () { return $ce8f7f35ea23371e$export$c6b2bc652e6118; });
$parcel$export(module.exports, "BigIntString", function () { return $ce8f7f35ea23371e$export$bee71b7ad39c148a; });
$parcel$export(module.exports, "IntNumber", function () { return $ce8f7f35ea23371e$export$7c3301b1967fe22e; });
$parcel$export(module.exports, "RegExpString", function () { return $ce8f7f35ea23371e$export$1a49548ec7b29d35; });
function $ce8f7f35ea23371e$export$8fcda2aa2242ba62() {
    return (value)=>value;
}
const $ce8f7f35ea23371e$export$8eb9ec7304489e21 = $ce8f7f35ea23371e$export$8fcda2aa2242ba62();
const $ce8f7f35ea23371e$export$c6b2bc652e6118 = $ce8f7f35ea23371e$export$8fcda2aa2242ba62();
const $ce8f7f35ea23371e$export$bee71b7ad39c148a = $ce8f7f35ea23371e$export$8fcda2aa2242ba62();
function $ce8f7f35ea23371e$export$7c3301b1967fe22e(num) {
    return Math.floor(num);
}
const $ce8f7f35ea23371e$export$1a49548ec7b29d35 = $ce8f7f35ea23371e$export$8fcda2aa2242ba62();

});




parcelRegister("ilDIY", function(module, exports) {

$parcel$export(module.exports, "fetchRPCRequest", function () { return $d5b9009b2639747d$export$64d75cabcdf878ea; });
$parcel$export(module.exports, "getCoinbaseInjectedProvider", function () { return $d5b9009b2639747d$export$69ab1b4a43f282eb; });
$parcel$export(module.exports, "checkErrorForInvalidRequestArgs", function () { return $d5b9009b2639747d$export$fbd10c013f9be089; });

var $jFsv4 = parcelRequire("jFsv4");

var $atSr3 = parcelRequire("atSr3");
async function $d5b9009b2639747d$export$64d75cabcdf878ea(request, rpcUrl) {
    const requestBody = Object.assign(Object.assign({}, request), {
        jsonrpc: "2.0",
        id: crypto.randomUUID()
    });
    const res = await window.fetch(rpcUrl, {
        method: "POST",
        body: JSON.stringify(requestBody),
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "X-Cbw-Sdk-Version": (0, $jFsv4.VERSION),
            "X-Cbw-Sdk-Platform": (0, $jFsv4.NAME)
        }
    });
    const { result: result, error: error } = await res.json();
    if (error) throw error;
    return result;
}
function $d5b9009b2639747d$var$getCoinbaseInjectedLegacyProvider() {
    const window1 = globalThis;
    return window1.coinbaseWalletExtension;
}
function $d5b9009b2639747d$var$getInjectedEthereum() {
    var _a, _b;
    try {
        const window1 = globalThis;
        return (_a = window1.ethereum) !== null && _a !== void 0 ? _a : (_b = window1.top) === null || _b === void 0 ? void 0 : _b.ethereum;
    } catch (_c) {
        return undefined;
    }
}
function $d5b9009b2639747d$export$69ab1b4a43f282eb({ metadata: metadata, preference: preference }) {
    var _a, _b;
    const { appName: appName, appLogoUrl: appLogoUrl, appChainIds: appChainIds } = metadata;
    if (preference.options !== "smartWalletOnly") {
        const extension = $d5b9009b2639747d$var$getCoinbaseInjectedLegacyProvider();
        if (extension) {
            (_a = extension.setAppInfo) === null || _a === void 0 || _a.call(extension, appName, appLogoUrl, appChainIds, preference);
            return extension;
        }
    }
    const ethereum = $d5b9009b2639747d$var$getInjectedEthereum();
    if (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isCoinbaseBrowser) {
        (_b = ethereum.setAppInfo) === null || _b === void 0 || _b.call(ethereum, appName, appLogoUrl, appChainIds, preference);
        return ethereum;
    }
    return undefined;
}
function $d5b9009b2639747d$export$fbd10c013f9be089(args) {
    if (!args || typeof args !== "object" || Array.isArray(args)) throw (0, $atSr3.standardErrors).rpc.invalidParams({
        message: "Expected a single, non-array, object argument.",
        data: args
    });
    const { method: method, params: params } = args;
    if (typeof method !== "string" || method.length === 0) throw (0, $atSr3.standardErrors).rpc.invalidParams({
        message: "'args.method' must be a non-empty string.",
        data: args
    });
    if (params !== undefined && !Array.isArray(params) && (typeof params !== "object" || params === null)) throw (0, $atSr3.standardErrors).rpc.invalidParams({
        message: "'args.params' must be an object or array if provided.",
        data: args
    });
    switch(method){
        case "eth_sign":
        case "eth_signTypedData_v2":
        case "eth_subscribe":
        case "eth_unsubscribe":
            throw (0, $atSr3.standardErrors).provider.unsupportedMethod();
    }
}

});
parcelRegister("jFsv4", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $e517f43155421c24$export$a4ad2735b021c132; });
$parcel$export(module.exports, "NAME", function () { return $e517f43155421c24$export$3c5e605ca7ade9f2; });
const $e517f43155421c24$export$a4ad2735b021c132 = "4.3.0";
const $e517f43155421c24$export$3c5e605ca7ade9f2 = "@coinbase/wallet-sdk";

});



parcelRegister("3078i", function(module, exports) {

$parcel$export(module.exports, "WalletLinkSigner", function () { return $22f6e79bad393721$export$8fdf04c6d830effb; });
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $AynAL = parcelRequire("AynAL");

var $he9Qx = parcelRequire("he9Qx");

var $lozWh = parcelRequire("lozWh");

var $9ONtv = parcelRequire("9ONtv");

var $j7Ao4 = parcelRequire("j7Ao4");

var $atSr3 = parcelRequire("atSr3");

var $bujE1 = parcelRequire("bujE1");

var $bJoUW = parcelRequire("bJoUW");

var $ilDIY = parcelRequire("ilDIY");

var $98IaM = parcelRequire("98IaM");
var $22f6e79bad393721$require$Buffer = $98IaM.Buffer;
const $22f6e79bad393721$var$DEFAULT_CHAIN_ID_KEY = "DefaultChainId";
const $22f6e79bad393721$var$DEFAULT_JSON_RPC_URL = "DefaultJsonRpcUrl";
class $22f6e79bad393721$export$8fdf04c6d830effb {
    constructor(options){
        this._relay = null;
        this._addresses = [];
        this.metadata = options.metadata;
        this._storage = new (0, $bujE1.ScopedLocalStorage)("walletlink", (0, $j7Ao4.WALLETLINK_URL));
        this.callback = options.callback || null;
        const cachedAddresses = this._storage.getItem((0, $he9Qx.LOCAL_STORAGE_ADDRESSES_KEY));
        if (cachedAddresses) {
            const addresses = cachedAddresses.split(" ");
            if (addresses[0] !== "") this._addresses = addresses.map((address)=>(0, $bJoUW.ensureAddressString)(address));
        }
        this.initializeRelay();
    }
    getSession() {
        const relay = this.initializeRelay();
        const { id: id, secret: secret } = relay.getWalletLinkSession();
        return {
            id: id,
            secret: secret
        };
    }
    async handshake() {
        await this._eth_requestAccounts();
    }
    get selectedAddress() {
        return this._addresses[0] || undefined;
    }
    get jsonRpcUrl() {
        var _a;
        return (_a = this._storage.getItem($22f6e79bad393721$var$DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : undefined;
    }
    set jsonRpcUrl(value) {
        this._storage.setItem($22f6e79bad393721$var$DEFAULT_JSON_RPC_URL, value);
    }
    updateProviderInfo(jsonRpcUrl, chainId) {
        var _a;
        this.jsonRpcUrl = jsonRpcUrl;
        // emit chainChanged event if necessary
        const originalChainId = this.getChainId();
        this._storage.setItem($22f6e79bad393721$var$DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
        const chainChanged = (0, $bJoUW.ensureIntNumber)(chainId) !== originalChainId;
        if (chainChanged) (_a = this.callback) === null || _a === void 0 || _a.call(this, "chainChanged", (0, $bJoUW.hexStringFromNumber)(chainId));
    }
    async watchAsset(params) {
        const request = Array.isArray(params) ? params[0] : params;
        if (!request.type) throw (0, $atSr3.standardErrors).rpc.invalidParams("Type is required");
        if ((request === null || request === void 0 ? void 0 : request.type) !== "ERC20") throw (0, $atSr3.standardErrors).rpc.invalidParams(`Asset of type '${request.type}' is not supported`);
        if (!(request === null || request === void 0 ? void 0 : request.options)) throw (0, $atSr3.standardErrors).rpc.invalidParams("Options are required");
        if (!(request === null || request === void 0 ? void 0 : request.options.address)) throw (0, $atSr3.standardErrors).rpc.invalidParams("Address is required");
        const chainId = this.getChainId();
        const { address: address, symbol: symbol, image: image, decimals: decimals } = request.options;
        const relay = this.initializeRelay();
        const result = await relay.watchAsset(request.type, address, symbol, decimals, image, chainId === null || chainId === void 0 ? void 0 : chainId.toString());
        if ((0, $lozWh.isErrorResponse)(result)) return false;
        return !!result.result;
    }
    async addEthereumChain(params) {
        var _a, _b;
        const request = params[0];
        if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) throw (0, $atSr3.standardErrors).rpc.invalidParams("please pass in at least 1 rpcUrl");
        if (!request.chainName || request.chainName.trim() === "") throw (0, $atSr3.standardErrors).rpc.invalidParams("chainName is a required field");
        if (!request.nativeCurrency) throw (0, $atSr3.standardErrors).rpc.invalidParams("nativeCurrency is a required field");
        const chainIdNumber = Number.parseInt(request.chainId, 16);
        if (chainIdNumber === this.getChainId()) return false;
        const relay = this.initializeRelay();
        const { rpcUrls: rpcUrls = [], blockExplorerUrls: blockExplorerUrls = [], chainName: chainName, iconUrls: iconUrls = [], nativeCurrency: nativeCurrency } = request;
        const res = await relay.addEthereumChain(chainIdNumber.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency);
        if ((0, $lozWh.isErrorResponse)(res)) return false;
        if (((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true) {
            this.updateProviderInfo(rpcUrls[0], chainIdNumber);
            return null;
        }
        throw (0, $atSr3.standardErrors).rpc.internal("unable to add ethereum chain");
    }
    async switchEthereumChain(params) {
        const request = params[0];
        const chainId = Number.parseInt(request.chainId, 16);
        const relay = this.initializeRelay();
        const res = await relay.switchEthereumChain(chainId.toString(10), this.selectedAddress || undefined);
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        const switchResponse = res.result;
        if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) this.updateProviderInfo(switchResponse.rpcUrl, chainId);
        return null;
    }
    async cleanup() {
        this.callback = null;
        if (this._relay) this._relay.resetAndReload();
        this._storage.clear();
    }
    _setAddresses(addresses, _) {
        var _a;
        if (!Array.isArray(addresses)) throw new Error("addresses is not an array");
        const newAddresses = addresses.map((address)=>(0, $bJoUW.ensureAddressString)(address));
        if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) return;
        this._addresses = newAddresses;
        (_a = this.callback) === null || _a === void 0 || _a.call(this, "accountsChanged", newAddresses);
        this._storage.setItem((0, $he9Qx.LOCAL_STORAGE_ADDRESSES_KEY), newAddresses.join(" "));
    }
    async request(request) {
        const params = request.params || [];
        switch(request.method){
            case "eth_accounts":
                return [
                    ...this._addresses
                ];
            case "eth_coinbase":
                return this.selectedAddress || null;
            case "net_version":
                return this.getChainId().toString(10);
            case "eth_chainId":
                return (0, $bJoUW.hexStringFromNumber)(this.getChainId());
            case "eth_requestAccounts":
                return this._eth_requestAccounts();
            case "eth_ecRecover":
            case "personal_ecRecover":
                return this.ecRecover(request);
            case "personal_sign":
                return this.personalSign(request);
            case "eth_signTransaction":
                return this._eth_signTransaction(params);
            case "eth_sendRawTransaction":
                return this._eth_sendRawTransaction(params);
            case "eth_sendTransaction":
                return this._eth_sendTransaction(params);
            case "eth_signTypedData_v1":
            case "eth_signTypedData_v3":
            case "eth_signTypedData_v4":
            case "eth_signTypedData":
                return this.signTypedData(request);
            case "wallet_addEthereumChain":
                return this.addEthereumChain(params);
            case "wallet_switchEthereumChain":
                return this.switchEthereumChain(params);
            case "wallet_watchAsset":
                return this.watchAsset(params);
            default:
                if (!this.jsonRpcUrl) throw (0, $atSr3.standardErrors).rpc.internal("No RPC URL set for chain");
                return (0, $ilDIY.fetchRPCRequest)(request, this.jsonRpcUrl);
        }
    }
    _ensureKnownAddress(addressString) {
        const addressStr = (0, $bJoUW.ensureAddressString)(addressString);
        const lowercaseAddresses = this._addresses.map((address)=>(0, $bJoUW.ensureAddressString)(address));
        if (!lowercaseAddresses.includes(addressStr)) throw new Error("Unknown Ethereum address");
    }
    _prepareTransactionParams(tx) {
        const fromAddress = tx.from ? (0, $bJoUW.ensureAddressString)(tx.from) : this.selectedAddress;
        if (!fromAddress) throw new Error("Ethereum address is unavailable");
        this._ensureKnownAddress(fromAddress);
        const toAddress = tx.to ? (0, $bJoUW.ensureAddressString)(tx.to) : null;
        const weiValue = tx.value != null ? (0, $bJoUW.ensureBigInt)(tx.value) : BigInt(0);
        const data = tx.data ? (0, $bJoUW.ensureBuffer)(tx.data) : $22f6e79bad393721$require$Buffer.alloc(0);
        const nonce = tx.nonce != null ? (0, $bJoUW.ensureIntNumber)(tx.nonce) : null;
        const gasPriceInWei = tx.gasPrice != null ? (0, $bJoUW.ensureBigInt)(tx.gasPrice) : null;
        const maxFeePerGas = tx.maxFeePerGas != null ? (0, $bJoUW.ensureBigInt)(tx.maxFeePerGas) : null;
        const maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? (0, $bJoUW.ensureBigInt)(tx.maxPriorityFeePerGas) : null;
        const gasLimit = tx.gas != null ? (0, $bJoUW.ensureBigInt)(tx.gas) : null;
        const chainId = tx.chainId ? (0, $bJoUW.ensureIntNumber)(tx.chainId) : this.getChainId();
        return {
            fromAddress: fromAddress,
            toAddress: toAddress,
            weiValue: weiValue,
            data: data,
            nonce: nonce,
            gasPriceInWei: gasPriceInWei,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            gasLimit: gasLimit,
            chainId: chainId
        };
    }
    async ecRecover(request) {
        const { method: method, params: params } = request;
        if (!Array.isArray(params)) throw (0, $atSr3.standardErrors).rpc.invalidParams();
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: "ethereumAddressFromSignedMessage",
            params: {
                message: (0, $bJoUW.encodeToHexString)(params[0]),
                signature: (0, $bJoUW.encodeToHexString)(params[1]),
                addPrefix: method === "personal_ecRecover"
            }
        });
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    getChainId() {
        var _a;
        return Number.parseInt((_a = this._storage.getItem($22f6e79bad393721$var$DEFAULT_CHAIN_ID_KEY)) !== null && _a !== void 0 ? _a : "1", 10);
    }
    async _eth_requestAccounts() {
        var _a, _b;
        if (this._addresses.length > 0) {
            (_a = this.callback) === null || _a === void 0 || _a.call(this, "connect", {
                chainId: (0, $bJoUW.hexStringFromNumber)(this.getChainId())
            });
            return this._addresses;
        }
        const relay = this.initializeRelay();
        const res = await relay.requestEthereumAccounts();
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        if (!res.result) throw new Error("accounts received is empty");
        this._setAddresses(res.result);
        (_b = this.callback) === null || _b === void 0 || _b.call(this, "connect", {
            chainId: (0, $bJoUW.hexStringFromNumber)(this.getChainId())
        });
        return this._addresses;
    }
    async personalSign({ params: params }) {
        if (!Array.isArray(params)) throw (0, $atSr3.standardErrors).rpc.invalidParams();
        const address = params[1];
        const rawData = params[0];
        this._ensureKnownAddress(address);
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: "signEthereumMessage",
            params: {
                address: (0, $bJoUW.ensureAddressString)(address),
                message: (0, $bJoUW.encodeToHexString)(rawData),
                addPrefix: true,
                typedDataJson: null
            }
        });
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    async _eth_signTransaction(params) {
        const tx = this._prepareTransactionParams(params[0] || {});
        const relay = this.initializeRelay();
        const res = await relay.signEthereumTransaction(tx);
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    async _eth_sendRawTransaction(params) {
        const signedTransaction = (0, $bJoUW.ensureBuffer)(params[0]);
        const relay = this.initializeRelay();
        const res = await relay.submitEthereumTransaction(signedTransaction, this.getChainId());
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    async _eth_sendTransaction(params) {
        const tx = this._prepareTransactionParams(params[0] || {});
        const relay = this.initializeRelay();
        const res = await relay.signAndSubmitEthereumTransaction(tx);
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    async signTypedData(request) {
        const { method: method, params: params } = request;
        if (!Array.isArray(params)) throw (0, $atSr3.standardErrors).rpc.invalidParams();
        const encode = (input)=>{
            const hashFuncMap = {
                eth_signTypedData_v1: (0, (/*@__PURE__*/$parcel$interopDefault($AynAL))).hashForSignTypedDataLegacy,
                eth_signTypedData_v3: (0, (/*@__PURE__*/$parcel$interopDefault($AynAL))).hashForSignTypedData_v3,
                eth_signTypedData_v4: (0, (/*@__PURE__*/$parcel$interopDefault($AynAL))).hashForSignTypedData_v4,
                eth_signTypedData: (0, (/*@__PURE__*/$parcel$interopDefault($AynAL))).hashForSignTypedData_v4
            };
            return (0, $bJoUW.hexStringFromBuffer)(hashFuncMap[method]({
                data: (0, $bJoUW.ensureParsedJSONObject)(input)
            }), true);
        };
        const address = params[method === "eth_signTypedData_v1" ? 1 : 0];
        const rawData = params[method === "eth_signTypedData_v1" ? 0 : 1];
        this._ensureKnownAddress(address);
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: "signEthereumMessage",
            params: {
                address: (0, $bJoUW.ensureAddressString)(address),
                message: encode(rawData),
                typedDataJson: JSON.stringify(rawData, null, 2),
                addPrefix: false
            }
        });
        if ((0, $lozWh.isErrorResponse)(res)) throw res;
        return res.result;
    }
    initializeRelay() {
        if (!this._relay) this._relay = new (0, $9ONtv.WalletLinkRelay)({
            linkAPIUrl: (0, $j7Ao4.WALLETLINK_URL),
            storage: this._storage,
            metadata: this.metadata,
            accountsCallback: this._setAddresses.bind(this),
            chainCallback: this.updateProviderInfo.bind(this)
        });
        return this._relay;
    }
}

});
parcelRegister("AynAL", function(module, exports) {
/* eslint-disable */ //prettier-ignore

var $98IaM = parcelRequire("98IaM");
var $cca42d5657d3a615$require$Buffer = $98IaM.Buffer;

var $1qYEA = parcelRequire("1qYEA");

var $gI55d = parcelRequire("gI55d");
const $cca42d5657d3a615$var$TYPED_MESSAGE_SCHEMA = {
    type: "object",
    properties: {
        types: {
            type: "object",
            additionalProperties: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: {
                            type: "string"
                        },
                        type: {
                            type: "string"
                        }
                    },
                    required: [
                        "name",
                        "type"
                    ]
                }
            }
        },
        primaryType: {
            type: "string"
        },
        domain: {
            type: "object"
        },
        message: {
            type: "object"
        }
    },
    required: [
        "types",
        "primaryType",
        "domain",
        "message"
    ]
};
/**
 * A collection of utility functions used for signing typed data
 */ const $cca42d5657d3a615$var$TypedDataUtils = {
    /**
   * Encodes an object by encoding and concatenating each of its members
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of an object
   */ encodeData (primaryType, data, types, useV4 = true) {
        const encodedTypes = [
            "bytes32"
        ];
        const encodedValues = [
            this.hashType(primaryType, types)
        ];
        if (useV4) {
            const encodeField = (name, type, value)=>{
                if (types[type] !== undefined) return [
                    "bytes32",
                    value == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : $1qYEA.keccak(this.encodeData(type, value, types, useV4))
                ];
                if (value === undefined) throw new Error(`missing value for field ${name} of type ${type}`);
                if (type === "bytes") return [
                    "bytes32",
                    $1qYEA.keccak(value)
                ];
                if (type === "string") {
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = $cca42d5657d3a615$require$Buffer.from(value, "utf8");
                    return [
                        "bytes32",
                        $1qYEA.keccak(value)
                    ];
                }
                if (type.lastIndexOf("]") === type.length - 1) {
                    const parsedType = type.slice(0, type.lastIndexOf("["));
                    const typeValuePairs = value.map((item)=>encodeField(name, parsedType, item));
                    return [
                        "bytes32",
                        $1qYEA.keccak($gI55d.rawEncode(typeValuePairs.map(([type])=>type), typeValuePairs.map(([, value])=>value)))
                    ];
                }
                return [
                    type,
                    value
                ];
            };
            for (const field of types[primaryType]){
                const [type, value] = encodeField(field.name, field.type, data[field.name]);
                encodedTypes.push(type);
                encodedValues.push(value);
            }
        } else for (const field of types[primaryType]){
            let value = data[field.name];
            if (value !== undefined) {
                if (field.type === "bytes") {
                    encodedTypes.push("bytes32");
                    value = $1qYEA.keccak(value);
                    encodedValues.push(value);
                } else if (field.type === "string") {
                    encodedTypes.push("bytes32");
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = $cca42d5657d3a615$require$Buffer.from(value, "utf8");
                    value = $1qYEA.keccak(value);
                    encodedValues.push(value);
                } else if (types[field.type] !== undefined) {
                    encodedTypes.push("bytes32");
                    value = $1qYEA.keccak(this.encodeData(field.type, value, types, useV4));
                    encodedValues.push(value);
                } else if (field.type.lastIndexOf("]") === field.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
                else {
                    encodedTypes.push(field.type);
                    encodedValues.push(value);
                }
            }
        }
        return $gI55d.rawEncode(encodedTypes, encodedValues);
    },
    /**
   * Encodes the type of an object by encoding a comma delimited list of its members
   *
   * @param {string} primaryType - Root type to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of the type of an object
   */ encodeType (primaryType, types) {
        let result = "";
        let deps = this.findTypeDependencies(primaryType, types).filter((dep)=>dep !== primaryType);
        deps = [
            primaryType
        ].concat(deps.sort());
        for (const type of deps){
            const children = types[type];
            if (!children) throw new Error("No type definition specified: " + type);
            result += type + "(" + types[type].map(({ name: name, type: type })=>type + " " + name).join(",") + ")";
        }
        return result;
    },
    /**
   * Finds all types within a type definition object
   *
   * @param {string} primaryType - Root type
   * @param {Object} types - Type definitions
   * @param {Array} results - current set of accumulated types
   * @returns {Array} - Set of all types found in the type definition
   */ findTypeDependencies (primaryType, types, results = []) {
        primaryType = primaryType.match(/^\w*/)[0];
        if (results.includes(primaryType) || types[primaryType] === undefined) return results;
        results.push(primaryType);
        for (const field of types[primaryType])for (const dep of this.findTypeDependencies(field.type, types, results))!results.includes(dep) && results.push(dep);
        return results;
    },
    /**
   * Hashes an object
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to hash
   * @param {Object} types - Type definitions
   * @returns {Buffer} - Hash of an object
   */ hashStruct (primaryType, data, types, useV4 = true) {
        return $1qYEA.keccak(this.encodeData(primaryType, data, types, useV4));
    },
    /**
   * Hashes the type of an object
   *
   * @param {string} primaryType - Root type to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */ hashType (primaryType, types) {
        return $1qYEA.keccak(this.encodeType(primaryType, types));
    },
    /**
   * Removes properties from a message object that are not defined per EIP-712
   *
   * @param {Object} data - typed message object
   * @returns {Object} - typed message object with only allowed fields
   */ sanitizeData (data) {
        const sanitizedData = {};
        for(const key in $cca42d5657d3a615$var$TYPED_MESSAGE_SCHEMA.properties)data[key] && (sanitizedData[key] = data[key]);
        if (sanitizedData.types) sanitizedData.types = Object.assign({
            EIP712Domain: []
        }, sanitizedData.types);
        return sanitizedData;
    },
    /**
   * Returns the hash of a typed message as per EIP-712 for signing
   *
   * @param {Object} typedData - Types message data to sign
   * @returns {string} - sha3 hash for signing
   */ hash (typedData, useV4 = true) {
        const sanitizedData = this.sanitizeData(typedData);
        const parts = [
            $cca42d5657d3a615$require$Buffer.from("1901", "hex")
        ];
        parts.push(this.hashStruct("EIP712Domain", sanitizedData.domain, sanitizedData.types, useV4));
        if (sanitizedData.primaryType !== "EIP712Domain") parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
        return $1qYEA.keccak($cca42d5657d3a615$require$Buffer.concat(parts));
    }
};
module.exports = {
    TYPED_MESSAGE_SCHEMA: $cca42d5657d3a615$var$TYPED_MESSAGE_SCHEMA,
    TypedDataUtils: $cca42d5657d3a615$var$TypedDataUtils,
    hashForSignTypedDataLegacy: function(msgParams) {
        return $cca42d5657d3a615$var$typedSignatureHashLegacy(msgParams.data);
    },
    hashForSignTypedData_v3: function(msgParams) {
        return $cca42d5657d3a615$var$TypedDataUtils.hash(msgParams.data, false);
    },
    hashForSignTypedData_v4: function(msgParams) {
        return $cca42d5657d3a615$var$TypedDataUtils.hash(msgParams.data);
    }
};
/**
 * @param typedData - Array of data along with types, as per EIP712.
 * @returns Buffer
 */ function $cca42d5657d3a615$var$typedSignatureHashLegacy(typedData) {
    const error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !typedData.length) throw error;
    const data = typedData.map(function(e) {
        return e.type === "bytes" ? $1qYEA.toBuffer(e.value) : e.value;
    });
    const types = typedData.map(function(e) {
        return e.type;
    });
    const schema = typedData.map(function(e) {
        if (!e.name) throw error;
        return e.type + " " + e.name;
    });
    return $gI55d.soliditySHA3([
        "bytes32",
        "bytes32"
    ], [
        $gI55d.soliditySHA3(new Array(typedData.length).fill("string"), schema),
        $gI55d.soliditySHA3(types, data)
    ]);
}

});
parcelRegister("1qYEA", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
// Original code licensed under the Mozilla Public License Version 2.0
/* eslint-disable */ //prettier-ignore

var $98IaM = parcelRequire("98IaM");
var $f4acd82568c4feb7$require$Buffer = $98IaM.Buffer;

var $ayMJF = parcelRequire("ayMJF");
var $f4acd82568c4feb7$require$keccak_256 = $ayMJF.keccak_256;
/**
 * Returns a buffer filled with 0s
 * @method zeros
 * @param {Number} bytes  the number of bytes the buffer should be
 * @return {Buffer}
 */ function $f4acd82568c4feb7$var$zeros(bytes) {
    return $f4acd82568c4feb7$require$Buffer.allocUnsafe(bytes).fill(0);
}
function $f4acd82568c4feb7$var$bitLengthFromBigInt(num) {
    return num.toString(2).length;
}
function $f4acd82568c4feb7$var$bufferBEFromBigInt(num, length) {
    let hex = num.toString(16);
    // Ensure the hex string length is even
    if (hex.length % 2 !== 0) hex = "0" + hex;
    // Convert hex string to a byte array
    const byteArray = hex.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16));
    // Ensure the byte array is of the specified length
    while(byteArray.length < length)byteArray.unshift(0); // Prepend with zeroes if shorter than required length
    return $f4acd82568c4feb7$require$Buffer.from(byteArray);
}
function $f4acd82568c4feb7$var$twosFromBigInt(value, width) {
    const isNegative = value < 0n;
    let result;
    if (isNegative) {
        // Prepare a mask for the specified width to perform NOT operation
        const mask = (1n << BigInt(width)) - 1n;
        // Invert bits (using NOT) and add one
        result = (~value & mask) + 1n;
    } else result = value;
    // Ensure the result fits in the specified width
    result &= (1n << BigInt(width)) - 1n;
    return result;
}
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @method setLength
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @param {Boolean} [right=false] whether to start padding form the left or right
 * @return {Buffer|Array}
 */ function $f4acd82568c4feb7$var$setLength(msg, length, right) {
    const buf = $f4acd82568c4feb7$var$zeros(length);
    msg = $f4acd82568c4feb7$var$toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
}
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @return {Buffer|Array}
 */ function $f4acd82568c4feb7$var$setLengthRight(msg, length) {
    return $f4acd82568c4feb7$var$setLength(msg, length, true);
}
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BIgInt` and other objects with a `toArray()` method.
 * @param {*} v the value
 */ function $f4acd82568c4feb7$var$toBuffer(v) {
    if (!$f4acd82568c4feb7$require$Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = $f4acd82568c4feb7$require$Buffer.from(v);
        else if (typeof v === "string") {
            if ($f4acd82568c4feb7$var$isHexString(v)) v = $f4acd82568c4feb7$require$Buffer.from($f4acd82568c4feb7$var$padToEven($f4acd82568c4feb7$var$stripHexPrefix(v)), "hex");
            else v = $f4acd82568c4feb7$require$Buffer.from(v);
        } else if (typeof v === "number") v = intToBuffer(v);
        else if (v === null || v === undefined) v = $f4acd82568c4feb7$require$Buffer.allocUnsafe(0);
        else if (typeof v === "bigint") v = $f4acd82568c4feb7$var$bufferBEFromBigInt(v);
        else if (v.toArray) // TODO: bigint should be handled above, may remove this duplicate
        // converts a BigInt to a Buffer
        v = $f4acd82568c4feb7$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}
/**
 * Converts a `Buffer` into a hex `String`
 * @param {Buffer} buf
 * @return {String}
 */ function $f4acd82568c4feb7$var$bufferToHex(buf) {
    buf = $f4acd82568c4feb7$var$toBuffer(buf);
    return "0x" + buf.toString("hex");
}
/**
 * Creates Keccak hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the Keccak width
 * @return {Buffer}
 */ function $f4acd82568c4feb7$var$keccak(a, bits) {
    a = $f4acd82568c4feb7$var$toBuffer(a);
    if (!bits) bits = 256;
    if (bits !== 256) throw new Error("unsupported");
    return $f4acd82568c4feb7$require$Buffer.from($f4acd82568c4feb7$require$keccak_256(new Uint8Array(a)));
}
function $f4acd82568c4feb7$var$padToEven(str) {
    return str.length % 2 ? "0" + str : str;
}
function $f4acd82568c4feb7$var$isHexString(str) {
    return typeof str === "string" && str.match(/^0x[0-9A-Fa-f]*$/);
}
function $f4acd82568c4feb7$var$stripHexPrefix(str) {
    if (typeof str === "string" && str.startsWith("0x")) return str.slice(2);
    return str;
}
module.exports = {
    zeros: $f4acd82568c4feb7$var$zeros,
    setLength: $f4acd82568c4feb7$var$setLength,
    setLengthRight: $f4acd82568c4feb7$var$setLengthRight,
    isHexString: $f4acd82568c4feb7$var$isHexString,
    stripHexPrefix: $f4acd82568c4feb7$var$stripHexPrefix,
    toBuffer: $f4acd82568c4feb7$var$toBuffer,
    bufferToHex: $f4acd82568c4feb7$var$bufferToHex,
    keccak: $f4acd82568c4feb7$var$keccak,
    bitLengthFromBigInt: $f4acd82568c4feb7$var$bitLengthFromBigInt,
    bufferBEFromBigInt: $f4acd82568c4feb7$var$bufferBEFromBigInt,
    twosFromBigInt: $f4acd82568c4feb7$var$twosFromBigInt
};

});
parcelRegister("ayMJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $7DTyc = parcelRequire("7DTyc");

var $hT1ya = parcelRequire("hT1ya");

var $bm2Jy = parcelRequire("bm2Jy");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $7b02e23bd697fcdd$var$SHA3_PI = [];
const $7b02e23bd697fcdd$var$SHA3_ROTL = [];
const $7b02e23bd697fcdd$var$_SHA3_IOTA = [];
const $7b02e23bd697fcdd$var$_0n = /* @__PURE__ */ BigInt(0);
const $7b02e23bd697fcdd$var$_1n = /* @__PURE__ */ BigInt(1);
const $7b02e23bd697fcdd$var$_2n = /* @__PURE__ */ BigInt(2);
const $7b02e23bd697fcdd$var$_7n = /* @__PURE__ */ BigInt(7);
const $7b02e23bd697fcdd$var$_256n = /* @__PURE__ */ BigInt(256);
const $7b02e23bd697fcdd$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $7b02e23bd697fcdd$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $7b02e23bd697fcdd$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $7b02e23bd697fcdd$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $7b02e23bd697fcdd$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $7b02e23bd697fcdd$var$_1n ^ (R >> $7b02e23bd697fcdd$var$_7n) * $7b02e23bd697fcdd$var$_0x71n) % $7b02e23bd697fcdd$var$_256n;
        if (R & $7b02e23bd697fcdd$var$_2n) t ^= $7b02e23bd697fcdd$var$_1n << ($7b02e23bd697fcdd$var$_1n << /* @__PURE__ */ BigInt(j)) - $7b02e23bd697fcdd$var$_1n;
    }
    $7b02e23bd697fcdd$var$_SHA3_IOTA.push(t);
}
const [$7b02e23bd697fcdd$var$SHA3_IOTA_H, $7b02e23bd697fcdd$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $hT1ya.split)($7b02e23bd697fcdd$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $7b02e23bd697fcdd$var$rotlH = (h, l, s)=>s > 32 ? (0, $hT1ya.rotlBH)(h, l, s) : (0, $hT1ya.rotlSH)(h, l, s);
const $7b02e23bd697fcdd$var$rotlL = (h, l, s)=>s > 32 ? (0, $hT1ya.rotlBL)(h, l, s) : (0, $hT1ya.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $7b02e23bd697fcdd$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $7b02e23bd697fcdd$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $7b02e23bd697fcdd$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $7b02e23bd697fcdd$var$SHA3_ROTL[t];
            const Th = $7b02e23bd697fcdd$var$rotlH(curH, curL, shift);
            const Tl = $7b02e23bd697fcdd$var$rotlL(curH, curL, shift);
            const PI = $7b02e23bd697fcdd$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $7b02e23bd697fcdd$var$SHA3_IOTA_H[round];
        s[1] ^= $7b02e23bd697fcdd$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $7b02e23bd697fcdd$var$keccakP;
class $7b02e23bd697fcdd$var$Keccak extends $bm2Jy.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $7DTyc.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $bm2Jy.u32)(this.state);
    }
    keccak() {
        if (!$bm2Jy.isLE) (0, $bm2Jy.byteSwap32)(this.state32);
        $7b02e23bd697fcdd$var$keccakP(this.state32, this.rounds);
        if (!$bm2Jy.isLE) (0, $bm2Jy.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $7DTyc.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $bm2Jy.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $7DTyc.exists)(this, false);
        (0, $7DTyc.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $7DTyc.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $7DTyc.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $7b02e23bd697fcdd$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $7b02e23bd697fcdd$var$Keccak;
const $7b02e23bd697fcdd$var$gen = (suffix, blockLen, outputLen)=>(0, $bm2Jy.wrapConstructor)(()=>new $7b02e23bd697fcdd$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $7b02e23bd697fcdd$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $7b02e23bd697fcdd$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $7b02e23bd697fcdd$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $7b02e23bd697fcdd$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $7b02e23bd697fcdd$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $7b02e23bd697fcdd$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $7b02e23bd697fcdd$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $7b02e23bd697fcdd$var$gen(0x01, 72, 64);
const $7b02e23bd697fcdd$var$genShake = (suffix, blockLen, outputLen)=>(0, $bm2Jy.wrapXOFConstructorWithOpts)((opts = {})=>new $7b02e23bd697fcdd$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $7b02e23bd697fcdd$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $7b02e23bd697fcdd$var$genShake(0x1f, 136, 32);

});
parcelRegister("7DTyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = module.exports.isBytes = void 0;
function $59074419ef90d632$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
module.exports.number = $59074419ef90d632$var$number;
function $59074419ef90d632$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
module.exports.bool = $59074419ef90d632$var$bool;
// copied from utils
function $59074419ef90d632$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $59074419ef90d632$var$isBytes;
function $59074419ef90d632$var$bytes(b, ...lengths) {
    if (!$59074419ef90d632$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $59074419ef90d632$var$bytes;
function $59074419ef90d632$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $59074419ef90d632$var$number(h.outputLen);
    $59074419ef90d632$var$number(h.blockLen);
}
module.exports.hash = $59074419ef90d632$var$hash;
function $59074419ef90d632$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $59074419ef90d632$var$exists;
function $59074419ef90d632$var$output(out, instance) {
    $59074419ef90d632$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $59074419ef90d632$var$output;
const $59074419ef90d632$var$assert = {
    number: $59074419ef90d632$var$number,
    bool: $59074419ef90d632$var$bool,
    bytes: $59074419ef90d632$var$bytes,
    hash: $59074419ef90d632$var$hash,
    exists: $59074419ef90d632$var$exists,
    output: $59074419ef90d632$var$output
};
module.exports.default = $59074419ef90d632$var$assert;

});

parcelRegister("hT1ya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $d058c68ba2304c71$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $d058c68ba2304c71$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $d058c68ba2304c71$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $d058c68ba2304c71$var$U32_MASK64),
        l: Number(n >> $d058c68ba2304c71$var$_32n & $d058c68ba2304c71$var$U32_MASK64)
    };
    return {
        h: Number(n >> $d058c68ba2304c71$var$_32n & $d058c68ba2304c71$var$U32_MASK64) | 0,
        l: Number(n & $d058c68ba2304c71$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $d058c68ba2304c71$var$fromBig;
function $d058c68ba2304c71$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $d058c68ba2304c71$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $d058c68ba2304c71$var$split;
const $d058c68ba2304c71$var$toBig = (h, l)=>BigInt(h >>> 0) << $d058c68ba2304c71$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $d058c68ba2304c71$var$toBig;
// for Shift in [0, 32)
const $d058c68ba2304c71$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $d058c68ba2304c71$var$shrSH;
const $d058c68ba2304c71$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $d058c68ba2304c71$var$shrSL;
// Right rotate for Shift in [1, 32)
const $d058c68ba2304c71$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $d058c68ba2304c71$var$rotrSH;
const $d058c68ba2304c71$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $d058c68ba2304c71$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $d058c68ba2304c71$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $d058c68ba2304c71$var$rotrBH;
const $d058c68ba2304c71$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $d058c68ba2304c71$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $d058c68ba2304c71$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $d058c68ba2304c71$var$rotr32H;
const $d058c68ba2304c71$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $d058c68ba2304c71$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $d058c68ba2304c71$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $d058c68ba2304c71$var$rotlSH;
const $d058c68ba2304c71$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $d058c68ba2304c71$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $d058c68ba2304c71$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $d058c68ba2304c71$var$rotlBH;
const $d058c68ba2304c71$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $d058c68ba2304c71$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $d058c68ba2304c71$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $d058c68ba2304c71$var$add;
// Addition with more than 2 elements
const $d058c68ba2304c71$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $d058c68ba2304c71$var$add3L;
const $d058c68ba2304c71$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $d058c68ba2304c71$var$add3H;
const $d058c68ba2304c71$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $d058c68ba2304c71$var$add4L;
const $d058c68ba2304c71$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $d058c68ba2304c71$var$add4H;
const $d058c68ba2304c71$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $d058c68ba2304c71$var$add5L;
const $d058c68ba2304c71$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $d058c68ba2304c71$var$add5H;
// prettier-ignore
const $d058c68ba2304c71$var$u64 = {
    fromBig: $d058c68ba2304c71$var$fromBig,
    split: $d058c68ba2304c71$var$split,
    toBig: $d058c68ba2304c71$var$toBig,
    shrSH: $d058c68ba2304c71$var$shrSH,
    shrSL: $d058c68ba2304c71$var$shrSL,
    rotrSH: $d058c68ba2304c71$var$rotrSH,
    rotrSL: $d058c68ba2304c71$var$rotrSL,
    rotrBH: $d058c68ba2304c71$var$rotrBH,
    rotrBL: $d058c68ba2304c71$var$rotrBL,
    rotr32H: $d058c68ba2304c71$var$rotr32H,
    rotr32L: $d058c68ba2304c71$var$rotr32L,
    rotlSH: $d058c68ba2304c71$var$rotlSH,
    rotlSL: $d058c68ba2304c71$var$rotlSL,
    rotlBH: $d058c68ba2304c71$var$rotlBH,
    rotlBL: $d058c68ba2304c71$var$rotlBL,
    add: $d058c68ba2304c71$var$add,
    add3L: $d058c68ba2304c71$var$add3L,
    add3H: $d058c68ba2304c71$var$add3H,
    add4L: $d058c68ba2304c71$var$add4L,
    add4H: $d058c68ba2304c71$var$add4H,
    add5H: $d058c68ba2304c71$var$add5H,
    add5L: $d058c68ba2304c71$var$add5L
};
module.exports.default = $d058c68ba2304c71$var$u64;

});

parcelRegister("bm2Jy", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.byteSwap32 = module.exports.byteSwapIfBE = module.exports.byteSwap = module.exports.isLE = module.exports.rotl = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = module.exports.isBytes = void 0;

var $fFx4W = parcelRequire("fFx4W");

var $7DTyc = parcelRequire("7DTyc");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $8443dea98cffe57f$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $8443dea98cffe57f$var$isBytes;
// Cast array to different type
const $8443dea98cffe57f$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $8443dea98cffe57f$var$u8;
const $8443dea98cffe57f$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $8443dea98cffe57f$var$u32;
// Cast array to view
const $8443dea98cffe57f$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $8443dea98cffe57f$var$createView;
// The rotate right (circular right shift) operation for uint32
const $8443dea98cffe57f$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $8443dea98cffe57f$var$rotr;
// The rotate left (circular left shift) operation for uint32
const $8443dea98cffe57f$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
module.exports.rotl = $8443dea98cffe57f$var$rotl;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const $8443dea98cffe57f$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
module.exports.byteSwap = $8443dea98cffe57f$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>(0, module.exports.byteSwap)(n);
// In place byte swap for Uint32Array
function $8443dea98cffe57f$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, module.exports.byteSwap)(arr[i]);
}
module.exports.byteSwap32 = $8443dea98cffe57f$var$byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $8443dea98cffe57f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $8443dea98cffe57f$var$bytesToHex(bytes) {
    (0, $7DTyc.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $8443dea98cffe57f$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $8443dea98cffe57f$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $8443dea98cffe57f$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $8443dea98cffe57f$var$asciiToBase16(char) {
    if (char >= $8443dea98cffe57f$var$asciis._0 && char <= $8443dea98cffe57f$var$asciis._9) return char - $8443dea98cffe57f$var$asciis._0;
    if (char >= $8443dea98cffe57f$var$asciis._A && char <= $8443dea98cffe57f$var$asciis._F) return char - ($8443dea98cffe57f$var$asciis._A - 10);
    if (char >= $8443dea98cffe57f$var$asciis._a && char <= $8443dea98cffe57f$var$asciis._f) return char - ($8443dea98cffe57f$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $8443dea98cffe57f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $8443dea98cffe57f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $8443dea98cffe57f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $8443dea98cffe57f$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $8443dea98cffe57f$var$nextTick = async ()=>{};
module.exports.nextTick = $8443dea98cffe57f$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $8443dea98cffe57f$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $8443dea98cffe57f$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $8443dea98cffe57f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $8443dea98cffe57f$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $8443dea98cffe57f$var$toBytes(data) {
    if (typeof data === "string") data = $8443dea98cffe57f$var$utf8ToBytes(data);
    (0, $7DTyc.bytes)(data);
    return data;
}
module.exports.toBytes = $8443dea98cffe57f$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $8443dea98cffe57f$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $7DTyc.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $8443dea98cffe57f$var$concatBytes;
// For runtime check if class implements interface
class $8443dea98cffe57f$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $8443dea98cffe57f$var$Hash;
const $8443dea98cffe57f$var$toStr = {}.toString;
function $8443dea98cffe57f$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $8443dea98cffe57f$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $8443dea98cffe57f$var$checkOpts;
function $8443dea98cffe57f$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($8443dea98cffe57f$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $8443dea98cffe57f$var$wrapConstructor;
function $8443dea98cffe57f$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($8443dea98cffe57f$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $8443dea98cffe57f$var$wrapConstructorWithOpts;
function $8443dea98cffe57f$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($8443dea98cffe57f$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $8443dea98cffe57f$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $8443dea98cffe57f$var$randomBytes(bytesLength = 32) {
    if ($fFx4W.crypto && typeof $fFx4W.crypto.getRandomValues === "function") return $fFx4W.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $8443dea98cffe57f$var$randomBytes;

});
parcelRegister("fFx4W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("gI55d", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi
/* eslint-disable */ //prettier-ignore

var $98IaM = parcelRequire("98IaM");
var $c4e225ade5d8625e$require$Buffer = $98IaM.Buffer;

var $1qYEA = parcelRequire("1qYEA");
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function $c4e225ade5d8625e$var$elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
// Parse N from type<N>
function $c4e225ade5d8625e$var$parseTypeN(type) {
    return Number.parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function $c4e225ade5d8625e$var$parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        Number.parseInt(tmp[1], 10),
        Number.parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function $c4e225ade5d8625e$var$parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : Number.parseInt(tmp[2], 10);
    return null;
}
function $c4e225ade5d8625e$var$parseNumber(arg) {
    var type = typeof arg;
    if (type === "string" || type === "number") return BigInt(arg);
    else if (type === "bigint") return arg;
    else throw new Error("Argument is not a number");
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function $c4e225ade5d8625e$var$encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return $c4e225ade5d8625e$var$encodeSingle("uint160", $c4e225ade5d8625e$var$parseNumber(arg));
    else if (type === "bool") return $c4e225ade5d8625e$var$encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return $c4e225ade5d8625e$var$encodeSingle("bytes", new $c4e225ade5d8625e$require$Buffer(arg, "utf8"));
    else if ($c4e225ade5d8625e$var$isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = $c4e225ade5d8625e$var$parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push($c4e225ade5d8625e$var$encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = $c4e225ade5d8625e$var$encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return $c4e225ade5d8625e$require$Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = new $c4e225ade5d8625e$require$Buffer(arg);
        ret = $c4e225ade5d8625e$require$Buffer.concat([
            $c4e225ade5d8625e$var$encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = $c4e225ade5d8625e$require$Buffer.concat([
            ret,
            $1qYEA.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = $c4e225ade5d8625e$var$parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return $1qYEA.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = $c4e225ade5d8625e$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = $c4e225ade5d8625e$var$parseNumber(arg);
        const bitLength = $1qYEA.bitLengthFromBigInt(num);
        if (bitLength > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + bitLength);
        if (num < 0) throw new Error("Supplied uint is negative");
        return $1qYEA.bufferBEFromBigInt(num, 32);
    } else if (type.startsWith("int")) {
        size = $c4e225ade5d8625e$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = $c4e225ade5d8625e$var$parseNumber(arg);
        const bitLength = $1qYEA.bitLengthFromBigInt(num);
        if (bitLength > size) throw new Error("Supplied int exceeds width: " + size + " vs " + bitLength);
        const twos = $1qYEA.twosFromBigInt(num, 256);
        return $1qYEA.bufferBEFromBigInt(twos, 32);
    } else if (type.startsWith("ufixed")) {
        size = $c4e225ade5d8625e$var$parseTypeNxM(type);
        num = $c4e225ade5d8625e$var$parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return $c4e225ade5d8625e$var$encodeSingle("uint256", num * BigInt(2) ** BigInt(size[1]));
    } else if (type.startsWith("fixed")) {
        size = $c4e225ade5d8625e$var$parseTypeNxM(type);
        return $c4e225ade5d8625e$var$encodeSingle("int256", $c4e225ade5d8625e$var$parseNumber(arg) * BigInt(2) ** BigInt(size[1]));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Is a type dynamic?
function $c4e225ade5d8625e$var$isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || $c4e225ade5d8625e$var$parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function $c4e225ade5d8625e$var$isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
function $c4e225ade5d8625e$var$rawEncode(types, values) {
    var output = [];
    var data = [];
    var headLength = 32 * types.length;
    for(var i in types){
        var type = $c4e225ade5d8625e$var$elementaryName(types[i]);
        var value = values[i];
        var cur = $c4e225ade5d8625e$var$encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if ($c4e225ade5d8625e$var$isDynamic(type)) {
            output.push($c4e225ade5d8625e$var$encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return $c4e225ade5d8625e$require$Buffer.concat(output.concat(data));
}
function $c4e225ade5d8625e$var$solidityPack(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var size, num;
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = $c4e225ade5d8625e$var$elementaryName(types[i]);
        var value = values[i];
        if (type === "bytes") ret.push(value);
        else if (type === "string") ret.push(new $c4e225ade5d8625e$require$Buffer(value, "utf8"));
        else if (type === "bool") ret.push(new $c4e225ade5d8625e$require$Buffer(value ? "01" : "00", "hex"));
        else if (type === "address") ret.push($1qYEA.setLength(value, 20));
        else if (type.startsWith("bytes")) {
            size = $c4e225ade5d8625e$var$parseTypeN(type);
            if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
            ret.push($1qYEA.setLengthRight(value, size));
        } else if (type.startsWith("uint")) {
            size = $c4e225ade5d8625e$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
            num = $c4e225ade5d8625e$var$parseNumber(value);
            const bitLength = $1qYEA.bitLengthFromBigInt(num);
            if (bitLength > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + bitLength);
            ret.push($1qYEA.bufferBEFromBigInt(num, size / 8));
        } else if (type.startsWith("int")) {
            size = $c4e225ade5d8625e$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
            num = $c4e225ade5d8625e$var$parseNumber(value);
            const bitLength = $1qYEA.bitLengthFromBigInt(num);
            if (bitLength > size) throw new Error("Supplied int exceeds width: " + size + " vs " + bitLength);
            const twos = $1qYEA.twosFromBigInt(num, size);
            ret.push($1qYEA.bufferBEFromBigInt(twos, size / 8));
        } else // FIXME: support all other types
        throw new Error("Unsupported or invalid type: " + type);
    }
    return $c4e225ade5d8625e$require$Buffer.concat(ret);
}
function $c4e225ade5d8625e$var$soliditySHA3(types, values) {
    return $1qYEA.keccak($c4e225ade5d8625e$var$solidityPack(types, values));
}
module.exports = {
    rawEncode: $c4e225ade5d8625e$var$rawEncode,
    solidityPack: $c4e225ade5d8625e$var$solidityPack,
    soliditySHA3: $c4e225ade5d8625e$var$soliditySHA3
};

});


parcelRegister("he9Qx", function(module, exports) {

$parcel$export(module.exports, "WALLET_USER_NAME_KEY", function () { return $c8ab61c8e94961a8$export$b7178e15e1429a46; });
$parcel$export(module.exports, "LOCAL_STORAGE_ADDRESSES_KEY", function () { return $c8ab61c8e94961a8$export$510fac04658bd7c9; });
$parcel$export(module.exports, "APP_VERSION_KEY", function () { return $c8ab61c8e94961a8$export$f2822cf597e719cd; });
const $c8ab61c8e94961a8$export$b7178e15e1429a46 = "walletUsername";
const $c8ab61c8e94961a8$export$510fac04658bd7c9 = "Addresses";
const $c8ab61c8e94961a8$export$f2822cf597e719cd = "AppVersion";

});

parcelRegister("lozWh", function(module, exports) {

$parcel$export(module.exports, "isErrorResponse", function () { return $f937b79ee1b9e381$export$bea7bee8a87e7c52; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
function $f937b79ee1b9e381$export$bea7bee8a87e7c52(response) {
    return response.errorMessage !== undefined;
}

});

parcelRegister("9ONtv", function(module, exports) {

$parcel$export(module.exports, "WalletLinkRelay", function () { return $725f293d4d289db5$export$a07bc8847923b355; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $ldYaW = parcelRequire("ldYaW");

var $he9Qx = parcelRequire("he9Qx");

var $ib69W = parcelRequire("ib69W");

var $cx4lk = parcelRequire("cx4lk");

var $lozWh = parcelRequire("lozWh");

var $doMlI = parcelRequire("doMlI");

var $bgkUJ = parcelRequire("bgkUJ");

var $ajpJZ = parcelRequire("ajpJZ");

var $atSr3 = parcelRequire("atSr3");

var $bujE1 = parcelRequire("bujE1");

var $bJoUW = parcelRequire("bJoUW");
class $725f293d4d289db5$export$a07bc8847923b355 {
    constructor(options){
        this.chainCallbackParams = {
            chainId: "",
            jsonRpcUrl: ""
        }; // to implement distinctUntilChanged
        this.isMobileWeb = (0, $doMlI.isMobileWeb)();
        this.linkedUpdated = (linked)=>{
            this.isLinked = linked;
            const cachedAddresses = this.storage.getItem((0, $he9Qx.LOCAL_STORAGE_ADDRESSES_KEY));
            if (linked) // Only set linked session variable one way
            this._session.linked = linked;
            this.isUnlinkedErrorState = false;
            if (cachedAddresses) {
                const addresses = cachedAddresses.split(" ");
                const wasConnectedViaStandalone = this.storage.getItem("IsStandaloneSigning") === "true";
                if (addresses[0] !== "" && !linked && this._session.linked && !wasConnectedViaStandalone) this.isUnlinkedErrorState = true;
            }
        };
        this.metadataUpdated = (key, value)=>{
            this.storage.setItem(key, value);
        };
        this.chainUpdated = (chainId, jsonRpcUrl)=>{
            if (this.chainCallbackParams.chainId === chainId && this.chainCallbackParams.jsonRpcUrl === jsonRpcUrl) return;
            this.chainCallbackParams = {
                chainId: chainId,
                jsonRpcUrl: jsonRpcUrl
            };
            if (this.chainCallback) this.chainCallback(jsonRpcUrl, Number.parseInt(chainId, 10));
        };
        this.accountUpdated = (selectedAddress)=>{
            if (this.accountsCallback) this.accountsCallback([
                selectedAddress
            ]);
            if ($725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.size > 0) {
                // We get the ethereum address from the metadata.  If for whatever
                // reason we don't get a response via an explicit web3 message
                // we can still fulfill the eip1102 request.
                Array.from($725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.values()).forEach((id)=>{
                    this.invokeCallback(id, {
                        method: "requestEthereumAccounts",
                        result: [
                            selectedAddress
                        ]
                    });
                });
                $725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.clear();
            }
        };
        this.resetAndReload = this.resetAndReload.bind(this);
        this.linkAPIUrl = options.linkAPIUrl;
        this.storage = options.storage;
        this.metadata = options.metadata;
        this.accountsCallback = options.accountsCallback;
        this.chainCallback = options.chainCallback;
        const { session: session, ui: ui, connection: connection } = this.subscribe();
        this._session = session;
        this.connection = connection;
        this.relayEventManager = new (0, $ib69W.RelayEventManager)();
        this.ui = ui;
        this.ui.attach();
    }
    subscribe() {
        const session = (0, $cx4lk.WalletLinkSession).load(this.storage) || (0, $cx4lk.WalletLinkSession).create(this.storage);
        const { linkAPIUrl: linkAPIUrl } = this;
        const connection = new (0, $ldYaW.WalletLinkConnection)({
            session: session,
            linkAPIUrl: linkAPIUrl,
            listener: this
        });
        const ui = this.isMobileWeb ? new (0, $ajpJZ.WLMobileRelayUI)() : new (0, $bgkUJ.WalletLinkRelayUI)();
        connection.connect();
        return {
            session: session,
            ui: ui,
            connection: connection
        };
    }
    resetAndReload() {
        this.connection.destroy().then(()=>{
            /**
             * Only clear storage if the session id we have in memory matches the one on disk
             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
             * storage already.  In that case if we clear storage again, the user will be in
             * a state where the first tab allows the user to connect but the session that
             * was used isn't persisted.  This leaves the user in a state where they aren't
             * connected to the mobile app.
             */ const storedSession = (0, $cx4lk.WalletLinkSession).load(this.storage);
            if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === this._session.id) (0, $bujE1.ScopedLocalStorage).clearAll();
            document.location.reload();
        }).catch((_)=>{});
    }
    signEthereumTransaction(params) {
        return this.sendRequest({
            method: "signEthereumTransaction",
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, $bJoUW.bigIntStringFromBigInt)(params.weiValue),
                data: (0, $bJoUW.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                maxFeePerGas: params.gasPriceInWei ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                maxPriorityFeePerGas: params.gasPriceInWei ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                gasLimit: params.gasLimit ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: false
            }
        });
    }
    signAndSubmitEthereumTransaction(params) {
        return this.sendRequest({
            method: "signEthereumTransaction",
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, $bJoUW.bigIntStringFromBigInt)(params.weiValue),
                data: (0, $bJoUW.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                maxFeePerGas: params.maxFeePerGas ? (0, $bJoUW.bigIntStringFromBigInt)(params.maxFeePerGas) : null,
                maxPriorityFeePerGas: params.maxPriorityFeePerGas ? (0, $bJoUW.bigIntStringFromBigInt)(params.maxPriorityFeePerGas) : null,
                gasLimit: params.gasLimit ? (0, $bJoUW.bigIntStringFromBigInt)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: true
            }
        });
    }
    submitEthereumTransaction(signedTransaction, chainId) {
        return this.sendRequest({
            method: "submitEthereumTransaction",
            params: {
                signedTransaction: (0, $bJoUW.hexStringFromBuffer)(signedTransaction, true),
                chainId: chainId
            }
        });
    }
    getWalletLinkSession() {
        return this._session;
    }
    sendRequest(request) {
        let hideSnackbarItem = null;
        const id = (0, $bJoUW.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        return new Promise((resolve, reject)=>{
            hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload
            });
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if ((0, $lozWh.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    publishWeb3RequestEvent(id, request) {
        const message = {
            type: "WEB3_REQUEST",
            id: id,
            request: request
        };
        this.publishEvent("Web3Request", message, true).then((_)=>{}).catch((err)=>{
            this.handleWeb3ResponseMessage(message.id, {
                method: request.method,
                errorMessage: err.message
            });
        });
        if (this.isMobileWeb) this.openCoinbaseWalletDeeplink(request.method);
    }
    // copied from MobileRelay
    openCoinbaseWalletDeeplink(method) {
        if (!(this.ui instanceof (0, $ajpJZ.WLMobileRelayUI))) return;
        // For mobile relay requests, open the Coinbase Wallet app
        switch(method){
            case "requestEthereumAccounts":
            case "switchEthereumChain":
                return;
            default:
                window.addEventListener("blur", ()=>{
                    window.addEventListener("focus", ()=>{
                        this.connection.checkUnseenEvents();
                    }, {
                        once: true
                    });
                }, {
                    once: true
                });
                this.ui.openCoinbaseWalletDeeplink();
                break;
        }
    }
    publishWeb3RequestCanceledEvent(id) {
        const message = {
            type: "WEB3_REQUEST_CANCELED",
            id: id
        };
        this.publishEvent("Web3RequestCanceled", message, false).then();
    }
    publishEvent(event, message, callWebhook) {
        return this.connection.publishEvent(event, message, callWebhook);
    }
    handleWeb3ResponseMessage(id, response) {
        if (response.method === "requestEthereumAccounts") {
            $725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.forEach((id)=>this.invokeCallback(id, response));
            $725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.clear();
            return;
        }
        this.invokeCallback(id, response);
    }
    handleErrorResponse(id, method, error) {
        var _a;
        const errorMessage = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "Unspecified error message.";
        this.handleWeb3ResponseMessage(id, {
            method: method,
            errorMessage: errorMessage
        });
    }
    invokeCallback(id, response) {
        const callback = this.relayEventManager.callbacks.get(id);
        if (callback) {
            callback(response);
            this.relayEventManager.callbacks.delete(id);
        }
    }
    requestEthereumAccounts() {
        const { appName: appName, appLogoUrl: appLogoUrl } = this.metadata;
        const request = {
            method: "requestEthereumAccounts",
            params: {
                appName: appName,
                appLogoUrl: appLogoUrl
            }
        };
        const hideSnackbarItem = null;
        const id = (0, $bJoUW.randomBytesHex)(8);
        return new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if ((0, $lozWh.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            $725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds.add(id);
            this.publishWeb3RequestEvent(id, request);
        });
    }
    watchAsset(type, address, symbol, decimals, image, chainId) {
        const request = {
            method: "watchAsset",
            params: {
                type: type,
                options: {
                    address: address,
                    symbol: symbol,
                    decimals: decimals,
                    image: image
                },
                chainId: chainId
            }
        };
        let hideSnackbarItem = null;
        const id = (0, $bJoUW.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload
        });
        return new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if ((0, $lozWh.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
        const request = {
            method: "addEthereumChain",
            params: {
                chainId: chainId,
                rpcUrls: rpcUrls,
                blockExplorerUrls: blockExplorerUrls,
                chainName: chainName,
                iconUrls: iconUrls,
                nativeCurrency: nativeCurrency
            }
        };
        let hideSnackbarItem = null;
        const id = (0, $bJoUW.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload
        });
        return new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if ((0, $lozWh.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    switchEthereumChain(chainId, address) {
        const request = {
            method: "switchEthereumChain",
            params: Object.assign({
                chainId: chainId
            }, {
                address: address
            })
        };
        let hideSnackbarItem = null;
        const id = (0, $bJoUW.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload
        });
        return new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if ((0, $lozWh.isErrorResponse)(response) && response.errorCode) return reject((0, $atSr3.standardErrors).provider.custom({
                    code: response.errorCode,
                    message: `Unrecognized chain ID. Try adding the chain using addEthereumChain first.`
                }));
                else if ((0, $lozWh.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
}
$725f293d4d289db5$export$a07bc8847923b355.accountRequestCallbackIds = new Set();

});
parcelRegister("ldYaW", function(module, exports) {

$parcel$export(module.exports, "WalletLinkConnection", function () { return $f7397d77d86ad388$export$467337b6b51f56ef; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $he9Qx = parcelRequire("he9Qx");

var $hS7Lz = parcelRequire("hS7Lz");

var $gD2wq = parcelRequire("gD2wq");

var $cMFdl = parcelRequire("cMFdl");

var $hJw2S = parcelRequire("hJw2S");
const $f7397d77d86ad388$var$HEARTBEAT_INTERVAL = 10000;
const $f7397d77d86ad388$var$REQUEST_TIMEOUT = 60000;
class $f7397d77d86ad388$export$467337b6b51f56ef {
    /**
     * Constructor
     * @param session Session
     * @param linkAPIUrl Coinbase Wallet link server URL
     * @param listener WalletLinkConnectionUpdateListener
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor({ session: session, linkAPIUrl: linkAPIUrl, listener: listener }){
        this.destroyed = false;
        this.lastHeartbeatResponse = 0;
        this.nextReqId = (0, $hJw2S.IntNumber)(1);
        /**
         * true if connected and authenticated, else false
         * runs listener when connected status changes
         */ this._connected = false;
        /**
         * true if linked (a guest has joined before)
         * runs listener when linked status changes
         */ this._linked = false;
        this.shouldFetchUnseenEventsOnConnect = false;
        this.requestResolutions = new Map();
        this.handleSessionMetadataUpdated = (metadata)=>{
            if (!metadata) return;
            // Map of metadata key to handler function
            const handlers = new Map([
                [
                    "__destroyed",
                    this.handleDestroyed
                ],
                [
                    "EthereumAddress",
                    this.handleAccountUpdated
                ],
                [
                    "WalletUsername",
                    this.handleWalletUsernameUpdated
                ],
                [
                    "AppVersion",
                    this.handleAppVersionUpdated
                ],
                [
                    "ChainId",
                    (v)=>metadata.JsonRpcUrl && this.handleChainUpdated(v, metadata.JsonRpcUrl)
                ]
            ]);
            // call handler for each metadata key if value is defined
            handlers.forEach((handler, key)=>{
                const value = metadata[key];
                if (value === undefined) return;
                handler(value);
            });
        };
        this.handleDestroyed = (__destroyed)=>{
            var _a;
            if (__destroyed !== "1") return;
            (_a = this.listener) === null || _a === void 0 || _a.resetAndReload();
        };
        this.handleAccountUpdated = async (encryptedEthereumAddress)=>{
            var _a;
            const address = await this.cipher.decrypt(encryptedEthereumAddress);
            (_a = this.listener) === null || _a === void 0 || _a.accountUpdated(address);
        };
        this.handleMetadataUpdated = async (key, encryptedMetadataValue)=>{
            var _a;
            const decryptedValue = await this.cipher.decrypt(encryptedMetadataValue);
            (_a = this.listener) === null || _a === void 0 || _a.metadataUpdated(key, decryptedValue);
        };
        this.handleWalletUsernameUpdated = async (walletUsername)=>{
            this.handleMetadataUpdated((0, $he9Qx.WALLET_USER_NAME_KEY), walletUsername);
        };
        this.handleAppVersionUpdated = async (appVersion)=>{
            this.handleMetadataUpdated((0, $he9Qx.APP_VERSION_KEY), appVersion);
        };
        this.handleChainUpdated = async (encryptedChainId, encryptedJsonRpcUrl)=>{
            var _a;
            const chainId = await this.cipher.decrypt(encryptedChainId);
            const jsonRpcUrl = await this.cipher.decrypt(encryptedJsonRpcUrl);
            (_a = this.listener) === null || _a === void 0 || _a.chainUpdated(chainId, jsonRpcUrl);
        };
        this.session = session;
        this.cipher = new (0, $hS7Lz.WalletLinkCipher)(session.secret);
        this.listener = listener;
        const ws = new (0, $cMFdl.WalletLinkWebSocket)(`${linkAPIUrl}/rpc`, WebSocket);
        ws.setConnectionStateListener(async (state)=>{
            // attempt to reconnect every 5 seconds when disconnected
            let connected = false;
            switch(state){
                case (0, $cMFdl.ConnectionState).DISCONNECTED:
                    // if DISCONNECTED and not destroyed
                    if (!this.destroyed) {
                        const connect = async ()=>{
                            // wait 5 seconds
                            await new Promise((resolve)=>setTimeout(resolve, 5000));
                            // check whether it's destroyed again
                            if (!this.destroyed) // reconnect
                            ws.connect().catch(()=>{
                                connect();
                            });
                        };
                        connect();
                    }
                    break;
                case (0, $cMFdl.ConnectionState).CONNECTED:
                    // perform authentication upon connection
                    // if CONNECTED, authenticate, and then check link status
                    connected = await this.handleConnected();
                    // send heartbeat every n seconds while connected
                    // if CONNECTED, start the heartbeat timer
                    // first timer event updates lastHeartbeat timestamp
                    // subsequent calls send heartbeat message
                    this.updateLastHeartbeat();
                    setInterval(()=>{
                        this.heartbeat();
                    }, $f7397d77d86ad388$var$HEARTBEAT_INTERVAL);
                    // check for unseen events
                    if (this.shouldFetchUnseenEventsOnConnect) this.fetchUnseenEventsAPI();
                    break;
                case (0, $cMFdl.ConnectionState).CONNECTING:
                    break;
            }
            // distinctUntilChanged
            if (this.connected !== connected) this.connected = connected;
        });
        ws.setIncomingDataListener((m)=>{
            var _a;
            switch(m.type){
                // handle server's heartbeat responses
                case "Heartbeat":
                    this.updateLastHeartbeat();
                    return;
                // handle link status updates
                case "IsLinkedOK":
                case "Linked":
                    {
                        const linked = m.type === "IsLinkedOK" ? m.linked : undefined;
                        this.linked = linked || m.onlineGuests > 0;
                        break;
                    }
                // handle session config updates
                case "GetSessionConfigOK":
                case "SessionConfigUpdated":
                    this.handleSessionMetadataUpdated(m.metadata);
                    break;
                case "Event":
                    this.handleIncomingEvent(m);
                    break;
            }
            // resolve request promises
            if (m.id !== undefined) (_a = this.requestResolutions.get(m.id)) === null || _a === void 0 || _a(m);
        });
        this.ws = ws;
        this.http = new (0, $gD2wq.WalletLinkHTTP)(linkAPIUrl, session.id, session.key);
    }
    /**
     * Make a connection to the server
     */ connect() {
        if (this.destroyed) throw new Error("instance is destroyed");
        this.ws.connect();
    }
    /**
     * Terminate connection, and mark as destroyed. To reconnect, create a new
     * instance of WalletSDKConnection
     */ async destroy() {
        if (this.destroyed) return;
        await this.makeRequest({
            type: "SetSessionConfig",
            id: (0, $hJw2S.IntNumber)(this.nextReqId++),
            sessionId: this.session.id,
            metadata: {
                __destroyed: "1"
            }
        }, {
            timeout: 1000
        });
        this.destroyed = true;
        this.ws.disconnect();
        this.listener = undefined;
    }
    get connected() {
        return this._connected;
    }
    set connected(connected) {
        this._connected = connected;
    }
    get linked() {
        return this._linked;
    }
    set linked(linked) {
        var _a, _b;
        this._linked = linked;
        if (linked) (_a = this.onceLinked) === null || _a === void 0 || _a.call(this);
        (_b = this.listener) === null || _b === void 0 || _b.linkedUpdated(linked);
    }
    setOnceLinked(callback) {
        return new Promise((resolve)=>{
            if (this.linked) callback().then(resolve);
            else this.onceLinked = ()=>{
                callback().then(resolve);
                this.onceLinked = undefined;
            };
        });
    }
    async handleIncomingEvent(m) {
        var _a;
        if (m.type !== "Event" || m.event !== "Web3Response") return;
        const decryptedData = await this.cipher.decrypt(m.data);
        const message = JSON.parse(decryptedData);
        if (message.type !== "WEB3_RESPONSE") return;
        const { id: id, response: response } = message;
        (_a = this.listener) === null || _a === void 0 || _a.handleWeb3ResponseMessage(id, response);
    }
    async checkUnseenEvents() {
        if (!this.connected) {
            this.shouldFetchUnseenEventsOnConnect = true;
            return;
        }
        await new Promise((resolve)=>setTimeout(resolve, 250));
        try {
            await this.fetchUnseenEventsAPI();
        } catch (e) {
            console.error("Unable to check for unseen events", e);
        }
    }
    async fetchUnseenEventsAPI() {
        this.shouldFetchUnseenEventsOnConnect = false;
        const responseEvents = await this.http.fetchUnseenEvents();
        responseEvents.forEach((e)=>this.handleIncomingEvent(e));
    }
    /**
     * Publish an event and emit event ID when successful
     * @param event event name
     * @param unencryptedData unencrypted event data
     * @param callWebhook whether the webhook should be invoked
     * @returns a Promise that emits event ID when successful
     */ async publishEvent(event, unencryptedData, callWebhook = false) {
        const data = await this.cipher.encrypt(JSON.stringify(Object.assign(Object.assign({}, unencryptedData), {
            origin: location.origin,
            location: location.href,
            relaySource: "coinbaseWalletExtension" in window && window.coinbaseWalletExtension ? "injected_sdk" : "sdk"
        })));
        const message = {
            type: "PublishEvent",
            id: (0, $hJw2S.IntNumber)(this.nextReqId++),
            sessionId: this.session.id,
            event: event,
            data: data,
            callWebhook: callWebhook
        };
        return this.setOnceLinked(async ()=>{
            const res = await this.makeRequest(message);
            if (res.type === "Fail") throw new Error(res.error || "failed to publish event");
            return res.eventId;
        });
    }
    sendData(message) {
        this.ws.sendData(JSON.stringify(message));
    }
    updateLastHeartbeat() {
        this.lastHeartbeatResponse = Date.now();
    }
    heartbeat() {
        if (Date.now() - this.lastHeartbeatResponse > $f7397d77d86ad388$var$HEARTBEAT_INTERVAL * 2) {
            this.ws.disconnect();
            return;
        }
        try {
            this.ws.sendData("h");
        } catch (_a) {
        // noop
        }
    }
    async makeRequest(message, options = {
        timeout: $f7397d77d86ad388$var$REQUEST_TIMEOUT
    }) {
        const reqId = message.id;
        this.sendData(message);
        // await server message with corresponding id
        let timeoutId;
        return Promise.race([
            new Promise((_, reject)=>{
                timeoutId = window.setTimeout(()=>{
                    reject(new Error(`request ${reqId} timed out`));
                }, options.timeout);
            }),
            new Promise((resolve)=>{
                this.requestResolutions.set(reqId, (m)=>{
                    clearTimeout(timeoutId); // clear the timeout
                    resolve(m);
                    this.requestResolutions.delete(reqId);
                });
            })
        ]);
    }
    async handleConnected() {
        const res = await this.makeRequest({
            type: "HostSession",
            id: (0, $hJw2S.IntNumber)(this.nextReqId++),
            sessionId: this.session.id,
            sessionKey: this.session.key
        });
        if (res.type === "Fail") return false;
        this.sendData({
            type: "IsLinked",
            id: (0, $hJw2S.IntNumber)(this.nextReqId++),
            sessionId: this.session.id
        });
        this.sendData({
            type: "GetSessionConfig",
            id: (0, $hJw2S.IntNumber)(this.nextReqId++),
            sessionId: this.session.id
        });
        return true;
    }
}

});
parcelRegister("hS7Lz", function(module, exports) {

$parcel$export(module.exports, "WalletLinkCipher", function () { return $d02d8107f947276d$export$34e4eb619f67fb91; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $bJoUW = parcelRequire("bJoUW");
class $d02d8107f947276d$export$34e4eb619f67fb91 {
    // @param secret hex representation of 32-byte secret
    constructor(secret){
        this.secret = secret;
    }
    /**
     *
     * @param plainText string to be encrypted
     * returns hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
     * encrypted plainText.
     */ async encrypt(plainText) {
        const secret = this.secret;
        if (secret.length !== 64) throw Error(`secret must be 256 bits`);
        const ivBytes = crypto.getRandomValues(new Uint8Array(12));
        const secretKey = await crypto.subtle.importKey("raw", (0, $bJoUW.hexStringToUint8Array)(secret), {
            name: "aes-gcm"
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        const enc = new TextEncoder();
        // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end
        const encryptedResult = await window.crypto.subtle.encrypt({
            name: "AES-GCM",
            iv: ivBytes
        }, secretKey, enc.encode(plainText));
        const tagLength = 16;
        const authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
        const encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
        const authTagBytes = new Uint8Array(authTag);
        const encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
        const concatted = new Uint8Array([
            ...ivBytes,
            ...authTagBytes,
            ...encryptedPlaintextBytes
        ]);
        return (0, $bJoUW.uint8ArrayToHex)(concatted);
    }
    /**
     *
     * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
     */ async decrypt(cipherText) {
        const secret = this.secret;
        if (secret.length !== 64) throw Error(`secret must be 256 bits`);
        return new Promise((resolve, reject)=>{
            (async function() {
                const secretKey = await crypto.subtle.importKey("raw", (0, $bJoUW.hexStringToUint8Array)(secret), {
                    name: "aes-gcm"
                }, false, [
                    "encrypt",
                    "decrypt"
                ]);
                const encrypted = (0, $bJoUW.hexStringToUint8Array)(cipherText);
                const ivBytes = encrypted.slice(0, 12);
                const authTagBytes = encrypted.slice(12, 28);
                const encryptedPlaintextBytes = encrypted.slice(28);
                const concattedBytes = new Uint8Array([
                    ...encryptedPlaintextBytes,
                    ...authTagBytes
                ]);
                const algo = {
                    name: "AES-GCM",
                    iv: new Uint8Array(ivBytes)
                };
                try {
                    const decrypted = await window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);
                    const decoder = new TextDecoder();
                    resolve(decoder.decode(decrypted));
                } catch (err) {
                    reject(err);
                }
            })();
        });
    }
}

});

parcelRegister("gD2wq", function(module, exports) {

$parcel$export(module.exports, "WalletLinkHTTP", function () { return $c1b23ea9b535d2e5$export$3b824f2f410edcd4; });
class $c1b23ea9b535d2e5$export$3b824f2f410edcd4 {
    constructor(linkAPIUrl, sessionId, sessionKey){
        this.linkAPIUrl = linkAPIUrl;
        this.sessionId = sessionId;
        const credentials = `${sessionId}:${sessionKey}`;
        this.auth = `Basic ${btoa(credentials)}`;
    }
    // mark unseen events as seen
    async markUnseenEventsAsSeen(events) {
        return Promise.all(events.map((e)=>fetch(`${this.linkAPIUrl}/events/${e.eventId}/seen`, {
                method: "POST",
                headers: {
                    Authorization: this.auth
                }
            }))).catch((error)=>console.error("Unabled to mark event as failed:", error));
    }
    async fetchUnseenEvents() {
        var _a;
        const response = await fetch(`${this.linkAPIUrl}/events?unseen=true`, {
            headers: {
                Authorization: this.auth
            }
        });
        if (response.ok) {
            const { events: events, error: error } = await response.json();
            if (error) throw new Error(`Check unseen events failed: ${error}`);
            const responseEvents = (_a = events === null || events === void 0 ? void 0 : events.filter((e)=>e.event === "Web3Response").map((e)=>({
                    type: "Event",
                    sessionId: this.sessionId,
                    eventId: e.id,
                    event: e.event,
                    data: e.data
                }))) !== null && _a !== void 0 ? _a : [];
            this.markUnseenEventsAsSeen(responseEvents);
            return responseEvents;
        }
        throw new Error(`Check unseen events failed: ${response.status}`);
    }
}

});

parcelRegister("cMFdl", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", function () { return $94e9f004bdf36062$export$cd9c3c6bf535afc9; });
$parcel$export(module.exports, "WalletLinkWebSocket", function () { return $94e9f004bdf36062$export$6e45162f9a43214e; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
var $94e9f004bdf36062$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
})($94e9f004bdf36062$export$cd9c3c6bf535afc9 || ($94e9f004bdf36062$export$cd9c3c6bf535afc9 = {}));
class $94e9f004bdf36062$export$6e45162f9a43214e {
    setConnectionStateListener(listener) {
        this.connectionStateListener = listener;
    }
    setIncomingDataListener(listener) {
        this.incomingDataListener = listener;
    }
    /**
     * Constructor
     * @param url WebSocket server URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor(url, WebSocketClass = WebSocket){
        this.WebSocketClass = WebSocketClass;
        this.webSocket = null;
        this.pendingData = [];
        this.url = url.replace(/^http/, "ws");
    }
    /**
     * Make a websocket connection
     * @returns a Promise that resolves when connected
     */ async connect() {
        if (this.webSocket) throw new Error("webSocket object is not null");
        return new Promise((resolve, reject)=>{
            var _a;
            let webSocket;
            try {
                this.webSocket = webSocket = new this.WebSocketClass(this.url);
            } catch (err) {
                reject(err);
                return;
            }
            (_a = this.connectionStateListener) === null || _a === void 0 || _a.call(this, $94e9f004bdf36062$export$cd9c3c6bf535afc9.CONNECTING);
            webSocket.onclose = (evt)=>{
                var _a;
                this.clearWebSocket();
                reject(new Error(`websocket error ${evt.code}: ${evt.reason}`));
                (_a = this.connectionStateListener) === null || _a === void 0 || _a.call(this, $94e9f004bdf36062$export$cd9c3c6bf535afc9.DISCONNECTED);
            };
            webSocket.onopen = (_)=>{
                var _a;
                resolve();
                (_a = this.connectionStateListener) === null || _a === void 0 || _a.call(this, $94e9f004bdf36062$export$cd9c3c6bf535afc9.CONNECTED);
                if (this.pendingData.length > 0) {
                    const pending = [
                        ...this.pendingData
                    ];
                    pending.forEach((data)=>this.sendData(data));
                    this.pendingData = [];
                }
            };
            webSocket.onmessage = (evt)=>{
                var _a, _b;
                if (evt.data === "h") (_a = this.incomingDataListener) === null || _a === void 0 || _a.call(this, {
                    type: "Heartbeat"
                });
                else try {
                    const message = JSON.parse(evt.data);
                    (_b = this.incomingDataListener) === null || _b === void 0 || _b.call(this, message);
                } catch (_c) {
                /* empty */ }
            };
        });
    }
    /**
     * Disconnect from server
     */ disconnect() {
        var _a;
        const { webSocket: webSocket } = this;
        if (!webSocket) return;
        this.clearWebSocket();
        (_a = this.connectionStateListener) === null || _a === void 0 || _a.call(this, $94e9f004bdf36062$export$cd9c3c6bf535afc9.DISCONNECTED);
        this.connectionStateListener = undefined;
        this.incomingDataListener = undefined;
        try {
            webSocket.close();
        } catch (_b) {
        // noop
        }
    }
    /**
     * Send data to server
     * @param data text to send
     */ sendData(data) {
        const { webSocket: webSocket } = this;
        if (!webSocket) {
            this.pendingData.push(data);
            this.connect();
            return;
        }
        webSocket.send(data);
    }
    clearWebSocket() {
        const { webSocket: webSocket } = this;
        if (!webSocket) return;
        this.webSocket = null;
        webSocket.onclose = null;
        webSocket.onerror = null;
        webSocket.onmessage = null;
        webSocket.onopen = null;
    }
}

});


parcelRegister("ib69W", function(module, exports) {

$parcel$export(module.exports, "RelayEventManager", function () { return $d3be082bfa4ae142$export$5c8443422713549c; });

var $bJoUW = parcelRequire("bJoUW");
class $d3be082bfa4ae142$export$5c8443422713549c {
    constructor(){
        this._nextRequestId = 0;
        this.callbacks = new Map();
    }
    makeRequestId() {
        // max nextId == max int32 for compatibility with mobile
        this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
        const id = this._nextRequestId;
        const idStr = (0, $bJoUW.prepend0x)(id.toString(16));
        // unlikely that this will ever be an issue, but just to be safe
        const callback = this.callbacks.get(idStr);
        if (callback) this.callbacks.delete(idStr);
        return id;
    }
}

});

parcelRegister("cx4lk", function(module, exports) {

$parcel$export(module.exports, "WalletLinkSession", function () { return $91fbef8aa57ec8f4$export$b41bb83ca4d19db8; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $1mHO3 = parcelRequire("1mHO3");

var $juPyd = parcelRequire("juPyd");

var $bJoUW = parcelRequire("bJoUW");
const $91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_ID = "session:id";
const $91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_SECRET = "session:secret";
const $91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_LINKED = "session:linked";
class $91fbef8aa57ec8f4$export$b41bb83ca4d19db8 {
    constructor(storage, id, secret, linked = false){
        this.storage = storage;
        this.id = id;
        this.secret = secret;
        this.key = (0, $juPyd.bytesToHex)((0, $1mHO3.sha256)(`${id}, ${secret} WalletLink`));
        this._linked = !!linked;
    }
    static create(storage) {
        const id = (0, $bJoUW.randomBytesHex)(16);
        const secret = (0, $bJoUW.randomBytesHex)(32);
        return new $91fbef8aa57ec8f4$export$b41bb83ca4d19db8(storage, id, secret).save();
    }
    static load(storage) {
        const id = storage.getItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_ID);
        const linked = storage.getItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_LINKED);
        const secret = storage.getItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_SECRET);
        if (id && secret) return new $91fbef8aa57ec8f4$export$b41bb83ca4d19db8(storage, id, secret, linked === "1");
        return null;
    }
    get linked() {
        return this._linked;
    }
    set linked(val) {
        this._linked = val;
        this.persistLinked();
    }
    save() {
        this.storage.setItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_ID, this.id);
        this.storage.setItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_SECRET, this.secret);
        this.persistLinked();
        return this;
    }
    persistLinked() {
        this.storage.setItem($91fbef8aa57ec8f4$var$STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
    }
}

});

parcelRegister("doMlI", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $9c13056bebbaf53c$export$e7fd20fad3cf4b5f; });
$parcel$export(module.exports, "isMobileWeb", function () { return $9c13056bebbaf53c$export$731e0c58cebf4a86; });
$parcel$export(module.exports, "isDarkMode", function () { return $9c13056bebbaf53c$export$41e2e80e2d68907a; });
function $9c13056bebbaf53c$export$4f5eb62a87086a68(sessionId, sessionSecret, serverUrl, isParentConnection, version, chainId) {
    const sessionIdKey = isParentConnection ? "parent-id" : "id";
    const query = new URLSearchParams({
        [sessionIdKey]: sessionId,
        secret: sessionSecret,
        server: serverUrl,
        v: version,
        chainId: chainId.toString()
    }).toString();
    const qrUrl = `${serverUrl}/#/link?${query}`;
    return qrUrl;
}
function $9c13056bebbaf53c$var$isInIFrame() {
    try {
        return window.frameElement !== null;
    } catch (e) {
        return false;
    }
}
function $9c13056bebbaf53c$export$e7fd20fad3cf4b5f() {
    try {
        if ($9c13056bebbaf53c$var$isInIFrame() && window.top) return window.top.location;
        return window.location;
    } catch (e) {
        return window.location;
    }
}
function $9c13056bebbaf53c$export$731e0c58cebf4a86() {
    var _a;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent);
}
function $9c13056bebbaf53c$export$41e2e80e2d68907a() {
    var _a, _b;
    return (_b = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-color-scheme: dark)").matches) !== null && _b !== void 0 ? _b : false;
}

});

parcelRegister("bgkUJ", function(module, exports) {

$parcel$export(module.exports, "WalletLinkRelayUI", function () { return $83316971c24a9a6b$export$cf599d3609f97c89; });

var $5ziK0 = parcelRequire("5ziK0");

var $5GJM2 = parcelRequire("5GJM2");
class $83316971c24a9a6b$export$cf599d3609f97c89 {
    constructor(){
        this.attached = false;
        this.snackbar = new (0, $5GJM2.Snackbar)();
    }
    attach() {
        if (this.attached) throw new Error("Coinbase Wallet SDK UI is already attached");
        const el = document.documentElement;
        const container = document.createElement("div");
        container.className = "-cbwsdk-css-reset";
        el.appendChild(container);
        this.snackbar.attach(container);
        this.attached = true;
        (0, $5ziK0.injectCssReset)();
    }
    showConnecting(options) {
        let snackbarProps;
        if (options.isUnlinkedErrorState) snackbarProps = {
            autoExpand: true,
            message: "Connection lost",
            menuItems: [
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        else snackbarProps = {
            message: "Confirm on phone",
            menuItems: [
                {
                    isRed: true,
                    info: "Cancel transaction",
                    svgWidth: "11",
                    svgHeight: "11",
                    path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
                    defaultFillRule: "inherit",
                    defaultClipRule: "inherit",
                    onClick: options.onCancel
                },
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        return this.snackbar.presentItem(snackbarProps);
    }
}

});
parcelRegister("5ziK0", function(module, exports) {

$parcel$export(module.exports, "injectCssReset", function () { return $40dec23ac10035cd$export$da1e1fa9ac5b0d6; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $bCK1f = parcelRequire("bCK1f");
function $40dec23ac10035cd$export$da1e1fa9ac5b0d6() {
    const styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode((0, $bCK1f.default)));
    document.documentElement.appendChild(styleEl);
}

});
parcelRegister("bCK1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8766f0c38cf86dd0$export$2e2bcd8739ae039; });
var $8766f0c38cf86dd0$export$2e2bcd8739ae039 = (()=>`@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}`)();

});


parcelRegister("5GJM2", function(module, exports) {

$parcel$export(module.exports, "Snackbar", function () { return $424461b22bf5b58e$export$9689b5d1b3e00abd; });
$parcel$export(module.exports, "SnackbarContainer", function () { return $424461b22bf5b58e$export$fe8275a9a0b320df; });
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>

var $ba4yE = parcelRequire("ba4yE");

var $bKUhe = parcelRequire("bKUhe");

var $8CpW1 = parcelRequire("8CpW1");

var $doMlI = parcelRequire("doMlI");

var $l2L8u = parcelRequire("l2L8u");
const $424461b22bf5b58e$var$cblogo = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;
const $424461b22bf5b58e$var$gearIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=`;
class $424461b22bf5b58e$export$9689b5d1b3e00abd {
    constructor(){
        this.items = new Map();
        this.nextItemKey = 0;
        this.root = null;
        this.darkMode = (0, $doMlI.isDarkMode)();
    }
    attach(el) {
        this.root = document.createElement("div");
        this.root.className = "-cbwsdk-snackbar-root";
        el.appendChild(this.root);
        this.render();
    }
    presentItem(itemProps) {
        const key = this.nextItemKey++;
        this.items.set(key, itemProps);
        this.render();
        return ()=>{
            this.items.delete(key);
            this.render();
        };
    }
    clear() {
        this.items.clear();
        this.render();
    }
    render() {
        if (!this.root) return;
        (0, $bKUhe.render)((0, $bKUhe.h)("div", null, (0, $bKUhe.h)($424461b22bf5b58e$export$fe8275a9a0b320df, {
            darkMode: this.darkMode
        }, Array.from(this.items.entries()).map(([key, itemProps])=>(0, $bKUhe.h)($424461b22bf5b58e$export$e1c7d014a0314ef, Object.assign({}, itemProps, {
                key: key
            }))))), this.root);
    }
}
const $424461b22bf5b58e$export$fe8275a9a0b320df = (props)=>(0, $bKUhe.h)("div", {
        class: (0, $ba4yE.clsx)("-cbwsdk-snackbar-container")
    }, (0, $bKUhe.h)("style", null, (0, $l2L8u.default)), (0, $bKUhe.h)("div", {
        class: "-cbwsdk-snackbar"
    }, props.children));
const $424461b22bf5b58e$export$e1c7d014a0314ef = ({ autoExpand: autoExpand, message: message, menuItems: menuItems })=>{
    const [hidden, setHidden] = (0, $8CpW1.useState)(true);
    const [expanded, setExpanded] = (0, $8CpW1.useState)(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false);
    (0, $8CpW1.useEffect)(()=>{
        const timers = [
            window.setTimeout(()=>{
                setHidden(false);
            }, 1),
            window.setTimeout(()=>{
                setExpanded(true);
            }, 10000)
        ];
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    });
    const toggleExpanded = ()=>{
        setExpanded(!expanded);
    };
    return (0, $bKUhe.h)("div", {
        class: (0, $ba4yE.clsx)("-cbwsdk-snackbar-instance", hidden && "-cbwsdk-snackbar-instance-hidden", expanded && "-cbwsdk-snackbar-instance-expanded")
    }, (0, $bKUhe.h)("div", {
        class: "-cbwsdk-snackbar-instance-header",
        onClick: toggleExpanded
    }, (0, $bKUhe.h)("img", {
        src: $424461b22bf5b58e$var$cblogo,
        class: "-cbwsdk-snackbar-instance-header-cblogo"
    }), " ", (0, $bKUhe.h)("div", {
        class: "-cbwsdk-snackbar-instance-header-message"
    }, message), (0, $bKUhe.h)("div", {
        class: "-gear-container"
    }, !expanded && (0, $bKUhe.h)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $bKUhe.h)("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#F5F7F8"
    })), (0, $bKUhe.h)("img", {
        src: $424461b22bf5b58e$var$gearIcon,
        class: "-gear-icon",
        title: "Expand"
    }))), menuItems && menuItems.length > 0 && (0, $bKUhe.h)("div", {
        class: "-cbwsdk-snackbar-instance-menu"
    }, menuItems.map((action, i)=>(0, $bKUhe.h)("div", {
            class: (0, $ba4yE.clsx)("-cbwsdk-snackbar-instance-menu-item", action.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"),
            onClick: action.onClick,
            key: i
        }, (0, $bKUhe.h)("svg", {
            width: action.svgWidth,
            height: action.svgHeight,
            viewBox: "0 0 10 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $bKUhe.h)("path", {
            "fill-rule": action.defaultFillRule,
            "clip-rule": action.defaultClipRule,
            d: action.path,
            fill: "#AAAAAA"
        })), (0, $bKUhe.h)("span", {
            class: (0, $ba4yE.clsx)("-cbwsdk-snackbar-instance-menu-item-info", action.isRed && "-cbwsdk-snackbar-instance-menu-item-info-is-red")
        }, action.info)))));
};

});
parcelRegister("l2L8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f51e59188f4d28a2$export$2e2bcd8739ae039; });
var $f51e59188f4d28a2$export$2e2bcd8739ae039 = (()=>`.-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}`)();

});



parcelRegister("ajpJZ", function(module, exports) {

$parcel$export(module.exports, "WLMobileRelayUI", function () { return $781fa551a32f5841$export$d92123f3c9c7aed8; });

var $b9ukq = parcelRequire("b9ukq");

var $doMlI = parcelRequire("doMlI");

var $j7Ao4 = parcelRequire("j7Ao4");
class $781fa551a32f5841$export$d92123f3c9c7aed8 {
    constructor(){
        this.attached = false;
        this.redirectDialog = new (0, $b9ukq.RedirectDialog)();
    }
    attach() {
        if (this.attached) throw new Error("Coinbase Wallet SDK UI is already attached");
        this.redirectDialog.attach();
        this.attached = true;
    }
    redirectToCoinbaseWallet(walletLinkUrl) {
        const url = new URL((0, $j7Ao4.CBW_MOBILE_DEEPLINK_URL));
        url.searchParams.append("redirect_url", (0, $doMlI.getLocation)().href);
        if (walletLinkUrl) url.searchParams.append("wl_url", walletLinkUrl);
        const anchorTag = document.createElement("a");
        anchorTag.target = "cbw-opener";
        anchorTag.href = url.href;
        anchorTag.rel = "noreferrer noopener";
        anchorTag.click();
    }
    openCoinbaseWalletDeeplink(walletLinkUrl) {
        this.redirectDialog.present({
            title: "Redirecting to Coinbase Wallet...",
            buttonText: "Open",
            onButtonClick: ()=>{
                this.redirectToCoinbaseWallet(walletLinkUrl);
            }
        });
        setTimeout(()=>{
            this.redirectToCoinbaseWallet(walletLinkUrl);
        }, 99);
    }
    showConnecting(_options) {
        // it uses the return callback to clear the dialog
        return ()=>{
            this.redirectDialog.clear();
        };
    }
}

});
parcelRegister("b9ukq", function(module, exports) {

$parcel$export(module.exports, "RedirectDialog", function () { return $81e80f8ea6953ba7$export$994eee00c370bf80; });

var $ba4yE = parcelRequire("ba4yE");

var $bKUhe = parcelRequire("bKUhe");

var $5ziK0 = parcelRequire("5ziK0");

var $5GJM2 = parcelRequire("5GJM2");

var $doMlI = parcelRequire("doMlI");

var $2xJQG = parcelRequire("2xJQG");
class $81e80f8ea6953ba7$export$994eee00c370bf80 {
    constructor(){
        this.root = null;
        this.darkMode = (0, $doMlI.isDarkMode)();
    }
    attach() {
        const el = document.documentElement;
        this.root = document.createElement("div");
        this.root.className = "-cbwsdk-css-reset";
        el.appendChild(this.root);
        (0, $5ziK0.injectCssReset)();
    }
    present(props) {
        this.render(props);
    }
    clear() {
        this.render(null);
    }
    render(props) {
        if (!this.root) return;
        (0, $bKUhe.render)(null, this.root);
        if (!props) return;
        (0, $bKUhe.render)((0, $bKUhe.h)($81e80f8ea6953ba7$var$RedirectDialogContent, Object.assign({}, props, {
            onDismiss: ()=>{
                this.clear();
            },
            darkMode: this.darkMode
        })), this.root);
    }
}
const $81e80f8ea6953ba7$var$RedirectDialogContent = ({ title: title, buttonText: buttonText, darkMode: darkMode, onButtonClick: onButtonClick, onDismiss: onDismiss })=>{
    const theme = darkMode ? "dark" : "light";
    return (0, $bKUhe.h)((0, $5GJM2.SnackbarContainer), {
        darkMode: darkMode
    }, (0, $bKUhe.h)("div", {
        class: "-cbwsdk-redirect-dialog"
    }, (0, $bKUhe.h)("style", null, (0, $2xJQG.default)), (0, $bKUhe.h)("div", {
        class: "-cbwsdk-redirect-dialog-backdrop",
        onClick: onDismiss
    }), (0, $bKUhe.h)("div", {
        class: (0, $ba4yE.clsx)("-cbwsdk-redirect-dialog-box", theme)
    }, (0, $bKUhe.h)("p", null, title), (0, $bKUhe.h)("button", {
        onClick: onButtonClick
    }, buttonText))));
};

});
parcelRegister("2xJQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1da23a768ead015f$export$2e2bcd8739ae039; });
var $1da23a768ead015f$export$2e2bcd8739ae039 = (()=>`.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop{position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s;background-color:rgba(10,11,13,.5)}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box{display:block;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);padding:20px;border-radius:8px;background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box p{display:block;font-weight:400;font-size:14px;line-height:20px;padding-bottom:12px;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box button{appearance:none;border:none;background:none;color:#0052ff;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark{background-color:#0a0b0d;color:#fff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark button{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light{background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light button{color:#0052ff}`)();

});


parcelRegister("j7Ao4", function(module, exports) {

$parcel$export(module.exports, "CB_KEYS_URL", function () { return $debae58589378982$export$59d79f929b219287; });
$parcel$export(module.exports, "CB_WALLET_RPC_URL", function () { return $debae58589378982$export$f1518b31703be242; });
$parcel$export(module.exports, "WALLETLINK_URL", function () { return $debae58589378982$export$28695e81beb211e1; });
$parcel$export(module.exports, "CBW_MOBILE_DEEPLINK_URL", function () { return $debae58589378982$export$e0a8f011ec6f958e; });
const $debae58589378982$export$59d79f929b219287 = "https://keys.coinbase.com/connect";
const $debae58589378982$export$f1518b31703be242 = "http://rpc.wallet.coinbase.com";
const $debae58589378982$export$28695e81beb211e1 = "https://www.walletlink.org";
const $debae58589378982$export$e0a8f011ec6f958e = "https://go.cb-w.com/walletlink";

});





parcelRegister("iRDie", function(module, exports) {

$parcel$export(module.exports, "Communicator", function () { return $dbbba8037657248c$export$ec474664c5a324f1; });

var $jFsv4 = parcelRequire("jFsv4");

var $j7Ao4 = parcelRequire("j7Ao4");

var $atSr3 = parcelRequire("atSr3");

var $6kEnR = parcelRequire("6kEnR");
class $dbbba8037657248c$export$ec474664c5a324f1 {
    constructor({ url: url = (0, $j7Ao4.CB_KEYS_URL), metadata: metadata, preference: preference }){
        this.popup = null;
        this.listeners = new Map();
        /**
         * Posts a message to the popup window
         */ this.postMessage = async (message)=>{
            const popup = await this.waitForPopupLoaded();
            popup.postMessage(message, this.url.origin);
        };
        /**
         * Posts a request to the popup window and waits for a response
         */ this.postRequestAndWaitForResponse = async (request)=>{
            const responsePromise = this.onMessage(({ requestId: requestId })=>requestId === request.id);
            this.postMessage(request);
            return await responsePromise;
        };
        /**
         * Listens for messages from the popup window that match a given predicate.
         */ this.onMessage = async (predicate)=>{
            return new Promise((resolve, reject)=>{
                const listener = (event)=>{
                    if (event.origin !== this.url.origin) return; // origin validation
                    const message = event.data;
                    if (predicate(message)) {
                        resolve(message);
                        window.removeEventListener("message", listener);
                        this.listeners.delete(listener);
                    }
                };
                window.addEventListener("message", listener);
                this.listeners.set(listener, {
                    reject: reject
                });
            });
        };
        /**
         * Closes the popup, rejects all requests and clears the listeners
         */ this.disconnect = ()=>{
            // Note: keys popup handles closing itself. this is a fallback.
            (0, $6kEnR.closePopup)(this.popup);
            this.popup = null;
            this.listeners.forEach(({ reject: reject }, listener)=>{
                reject((0, $atSr3.standardErrors).provider.userRejectedRequest("Request rejected"));
                window.removeEventListener("message", listener);
            });
            this.listeners.clear();
        };
        /**
         * Waits for the popup window to fully load and then sends a version message.
         */ this.waitForPopupLoaded = async ()=>{
            if (this.popup && !this.popup.closed) {
                // In case the user un-focused the popup between requests, focus it again
                this.popup.focus();
                return this.popup;
            }
            this.popup = (0, $6kEnR.openPopup)(this.url);
            this.onMessage(({ event: event })=>event === "PopupUnload").then(this.disconnect).catch(()=>{});
            return this.onMessage(({ event: event })=>event === "PopupLoaded").then((message)=>{
                this.postMessage({
                    requestId: message.id,
                    data: {
                        version: (0, $jFsv4.VERSION),
                        metadata: this.metadata,
                        preference: this.preference,
                        location: window.location.toString()
                    }
                });
            }).then(()=>{
                if (!this.popup) throw (0, $atSr3.standardErrors).rpc.internal();
                return this.popup;
            });
        };
        this.url = new URL(url);
        this.metadata = metadata;
        this.preference = preference;
    }
}

});
parcelRegister("6kEnR", function(module, exports) {

$parcel$export(module.exports, "openPopup", function () { return $49c3efb61f9f11fe$export$c70811ece640d3a1; });
$parcel$export(module.exports, "closePopup", function () { return $49c3efb61f9f11fe$export$e6889fb0929ccf91; });

var $jFsv4 = parcelRequire("jFsv4");

var $lhdkI = parcelRequire("lhdkI");

var $atSr3 = parcelRequire("atSr3");
const $49c3efb61f9f11fe$var$POPUP_WIDTH = 420;
const $49c3efb61f9f11fe$var$POPUP_HEIGHT = 540;
function $49c3efb61f9f11fe$export$c70811ece640d3a1(url) {
    const left = (window.innerWidth - $49c3efb61f9f11fe$var$POPUP_WIDTH) / 2 + window.screenX;
    const top = (window.innerHeight - $49c3efb61f9f11fe$var$POPUP_HEIGHT) / 2 + window.screenY;
    $49c3efb61f9f11fe$var$appendAppInfoQueryParams(url);
    const popupId = `wallet_${crypto.randomUUID()}`;
    const popup = window.open(url, popupId, `width=${$49c3efb61f9f11fe$var$POPUP_WIDTH}, height=${$49c3efb61f9f11fe$var$POPUP_HEIGHT}, left=${left}, top=${top}`);
    popup === null || popup === void 0 || popup.focus();
    if (!popup) throw (0, $atSr3.standardErrors).rpc.internal("Pop up window failed to open");
    return popup;
}
function $49c3efb61f9f11fe$export$e6889fb0929ccf91(popup) {
    if (popup && !popup.closed) popup.close();
}
function $49c3efb61f9f11fe$var$appendAppInfoQueryParams(url) {
    const params = {
        sdkName: (0, $jFsv4.NAME),
        sdkVersion: (0, $jFsv4.VERSION),
        origin: window.location.origin,
        coop: (0, $lhdkI.getCrossOriginOpenerPolicy)()
    };
    for (const [key, value] of Object.entries(params))url.searchParams.append(key, value.toString());
}

});
parcelRegister("lhdkI", function(module, exports) {

$parcel$export(module.exports, "checkCrossOriginOpenerPolicy", function () { return $f7d587302565ec5b$export$bf3fd8f7cd1cd0f6; });
$parcel$export(module.exports, "getCrossOriginOpenerPolicy", function () { return $f7d587302565ec5b$export$66b7eddf0c661b18; });
const $f7d587302565ec5b$var$COOP_ERROR_MESSAGE = `Coinbase Wallet SDK requires the Cross-Origin-Opener-Policy header to not be set to 'same-origin'. This is to ensure that the SDK can communicate with the Coinbase Smart Wallet app.

Please see https://www.smartwallet.dev/guides/tips/popup-tips#cross-origin-opener-policy for more information.`;
/**
 * Creates a checker for the Cross-Origin-Opener-Policy (COOP).
 *
 * @returns An object with methods to get and check the Cross-Origin-Opener-Policy.
 *
 * @method getCrossOriginOpenerPolicy
 * Retrieves current Cross-Origin-Opener-Policy.
 * @throws Will throw an error if the policy has not been checked yet.
 *
 * @method checkCrossOriginOpenerPolicy
 * Checks the Cross-Origin-Opener-Policy of the current environment.
 * If in a non-browser environment, sets the policy to 'non-browser-env'.
 * If in a browser environment, fetches the policy from the current origin.
 * Logs an error if the policy is 'same-origin'.
 */ const $f7d587302565ec5b$var$createCoopChecker = ()=>{
    let crossOriginOpenerPolicy;
    return {
        getCrossOriginOpenerPolicy: ()=>{
            if (crossOriginOpenerPolicy === undefined) return "undefined";
            return crossOriginOpenerPolicy;
        },
        checkCrossOriginOpenerPolicy: async ()=>{
            if (typeof window === "undefined") {
                // Non-browser environment
                crossOriginOpenerPolicy = "non-browser-env";
                return;
            }
            try {
                const url = `${window.location.origin}${window.location.pathname}`;
                const response = await fetch(url, {
                    method: "HEAD"
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const result = response.headers.get("Cross-Origin-Opener-Policy");
                crossOriginOpenerPolicy = result !== null && result !== void 0 ? result : "null";
                if (crossOriginOpenerPolicy === "same-origin") console.error($f7d587302565ec5b$var$COOP_ERROR_MESSAGE);
            } catch (error) {
                console.error("Error checking Cross-Origin-Opener-Policy:", error.message);
                crossOriginOpenerPolicy = "error";
            }
        }
    };
};
const { checkCrossOriginOpenerPolicy: $f7d587302565ec5b$export$bf3fd8f7cd1cd0f6, getCrossOriginOpenerPolicy: $f7d587302565ec5b$export$66b7eddf0c661b18 } = $f7d587302565ec5b$var$createCoopChecker();

});



parcelRegister("4qxTb", function(module, exports) {

$parcel$export(module.exports, "serializeError", function () { return $3393e0c9c7c32225$export$46ff38bc6bdea8fb; });
// TODO: error should not depend on walletlink. revisit this.

var $jFsv4 = parcelRequire("jFsv4");

var $lozWh = parcelRequire("lozWh");

var $9Zyam = parcelRequire("9Zyam");

var $7Xld6 = parcelRequire("7Xld6");
function $3393e0c9c7c32225$export$46ff38bc6bdea8fb(error) {
    const serialized = (0, $7Xld6.serialize)($3393e0c9c7c32225$var$getErrorObject(error), {
        shouldIncludeStack: true
    });
    const docUrl = new URL("https://docs.cloud.coinbase.com/wallet-sdk/docs/errors");
    docUrl.searchParams.set("version", (0, $jFsv4.VERSION));
    docUrl.searchParams.set("code", serialized.code.toString());
    docUrl.searchParams.set("message", serialized.message);
    return Object.assign(Object.assign({}, serialized), {
        docUrl: docUrl.href
    });
}
/**
 * Converts an error to a serializable object.
 */ function $3393e0c9c7c32225$var$getErrorObject(error) {
    var _a;
    if (typeof error === "string") return {
        message: error,
        code: (0, $9Zyam.standardErrorCodes).rpc.internal
    };
    else if ((0, $lozWh.isErrorResponse)(error)) {
        const message = error.errorMessage;
        const code = (_a = error.errorCode) !== null && _a !== void 0 ? _a : message.match(/(denied|rejected)/i) ? (0, $9Zyam.standardErrorCodes).provider.userRejectedRequest : undefined;
        return Object.assign(Object.assign({}, error), {
            message: message,
            code: code,
            data: {
                method: error.method
            }
        });
    }
    return error;
}

});

parcelRegister("fJmlL", function(module, exports) {

$parcel$export(module.exports, "ProviderEventEmitter", function () { return $b73c653fe18a94fe$export$72b040f461a56853; });

var $dZbfb = parcelRequire("dZbfb");
class $b73c653fe18a94fe$export$72b040f461a56853 extends (0, $dZbfb.EventEmitter) {
}

});


parcelRegister("jzuPG", function(module, exports) {

$parcel$export(module.exports, "validatePreferences", function () { return $e3f933eed76fbaf5$export$571378eab7f593d6; });
/**
 * Validates user supplied preferences. Throws if keys are not valid.
 * @param preference
 */ function $e3f933eed76fbaf5$export$571378eab7f593d6(preference) {
    if (!preference) return;
    if (![
        "all",
        "smartWalletOnly",
        "eoaOnly"
    ].includes(preference.options)) throw new Error(`Invalid options: ${preference.options}`);
    if (preference.attribution) {
        if (preference.attribution.auto !== undefined && preference.attribution.dataSuffix !== undefined) throw new Error(`Attribution cannot contain both auto and dataSuffix properties`);
    }
}

});


parcelRegister("jTmvn", function(module, exports) {

$parcel$export(module.exports, "createCoinbaseWalletSDK", function () { return $e7b49c708b505342$export$f561f80bb48283a9; });

var $fPKD1 = parcelRequire("fPKD1");

var $jFsv4 = parcelRequire("jFsv4");

var $bujE1 = parcelRequire("bujE1");

var $lhdkI = parcelRequire("lhdkI");

var $jzuPG = parcelRequire("jzuPG");
const $e7b49c708b505342$var$DEFAULT_PREFERENCE = {
    options: "all"
};
function $e7b49c708b505342$export$f561f80bb48283a9(params) {
    var _a;
    const versionStorage = new (0, $bujE1.ScopedLocalStorage)("CBWSDK");
    versionStorage.setItem("VERSION", (0, $jFsv4.VERSION));
    (0, $lhdkI.checkCrossOriginOpenerPolicy)();
    const options = {
        metadata: {
            appName: params.appName || "Dapp",
            appLogoUrl: params.appLogoUrl || "",
            appChainIds: params.appChainIds || []
        },
        preference: Object.assign($e7b49c708b505342$var$DEFAULT_PREFERENCE, (_a = params.preference) !== null && _a !== void 0 ? _a : {})
    };
    /**
     * Validate user supplied preferences. Throws if key/values are not valid.
     */ (0, $jzuPG.validatePreferences)(options.preference);
    let provider = null;
    return {
        getProvider: ()=>{
            if (!provider) provider = (0, $fPKD1.createCoinbaseWalletProvider)(options);
            return provider;
        }
    };
}

});
parcelRegister("fPKD1", function(module, exports) {

$parcel$export(module.exports, "createCoinbaseWalletProvider", function () { return $b86fc9dfdd60107f$export$8983e23b589504ab; });

var $eRkko = parcelRequire("eRkko");

var $ilDIY = parcelRequire("ilDIY");
function $b86fc9dfdd60107f$export$8983e23b589504ab(options) {
    var _a;
    const params = {
        metadata: options.metadata,
        preference: options.preference
    };
    return (_a = (0, $ilDIY.getCoinbaseInjectedProvider)(params)) !== null && _a !== void 0 ? _a : new (0, $eRkko.CoinbaseWalletProvider)(params);
}

});




//# sourceMappingURL=dist.8aef4ca8.js.map
